import React from 'react';
import {
  Button,
  Icon,
  IconButton,
  LinearGradient,
  NumberInput,
  ScreenContainer,
  SimpleStyleFlatList,
  SimpleStyleScrollView,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { BlurView } from 'expo-blur';
import { ActivityIndicator, Modal, Text, View } from 'react-native';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as DefaultApi from '../apis/DefaultApi.js';
import ScenarioBlock from '../components/ScenarioBlock';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import SideMenuBlock from '../components/SideMenuBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import * as BarChartWhatIf from '../custom-files/BarChartWhatIf';
import * as MatrixListIncome from '../custom-files/MatrixListIncome';
import addOrRemove from '../global-functions/addOrRemove';
import calculateCashOnHandFlow from '../global-functions/calculateCashOnHandFlow';
import calculatePercentIncome from '../global-functions/calculatePercentIncome';
import cashOnHand from '../global-functions/cashOnHand';
import checkScreenMode from '../global-functions/checkScreenMode';
import createObjectForPost from '../global-functions/createObjectForPost';
import findColumnRowNumber from '../global-functions/findColumnRowNumber';
import findIndextAllCategories from '../global-functions/findIndextAllCategories';
import formatNumber from '../global-functions/formatNumber';
import formatPercentage from '../global-functions/formatPercentage';
import generateDates from '../global-functions/generateDates';
import getCurrentYear from '../global-functions/getCurrentYear';
import getInitValue from '../global-functions/getInitValue';
import mergeCategoriesNumbers from '../global-functions/mergeCategoriesNumbers';
import newFormatDate from '../global-functions/newFormatDate';
import prefillNumberInputs from '../global-functions/prefillNumberInputs';
import sortCategories from '../global-functions/sortCategories';
import sumArrays from '../global-functions/sumArrays';
import timestampToISO from '../global-functions/timestampToISO';
import toFixed2 from '../global-functions/toFixed2';
import updateTableRows from '../global-functions/updateTableRows';
import palettes from '../themes/palettes';
import * as Utils from '../utils';
import Breakpoints from '../utils/Breakpoints';
import * as DateUtils from '../utils/DateUtils';
import * as StyleSheet from '../utils/StyleSheet';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = {
  exist_scenario_id: '',
  new_or_exist: 'new',
  scenario: null,
};

const WhatIfScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const [allCategories, setAllCategories] = React.useState([]);
  const [allCategoriesFinance, setAllCategoriesFinance] = React.useState([]);
  const [allCategoriesOperating, setAllCategoriesOperating] = React.useState(
    []
  );
  const [allCategoriesOther, setAllCategoriesOther] = React.useState([]);
  const [allCategoriesPayment, setAllCategoriesPayment] = React.useState('');
  const [buttonLabel, setButtonLabel] = React.useState('Create New');
  const [cashOnHandArray, setCashOnHandArray] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [cashOnHands, setCashOnHands] = React.useState({
    ending: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    beginning: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  const [financeData, setFinanceData] = React.useState('');
  const [incomeCategories, setIncomeCategories] = React.useState('');
  const [incomeData, setIncomeData] = React.useState('');
  const [isFetching, setIsFetching] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isUploading, setIsUploading] = React.useState(false);
  const [monthlyCashOnHand, setMonthlyCashOnHand] = React.useState([]);
  const [numberInputs, setNumberInputs] = React.useState([]);
  const [numberInputsFinance, setNumberInputsFinance] = React.useState([]);
  const [numberInputsIncome, setNumberInputsIncome] = React.useState('');
  const [numberInputsOperating, setNumberInputsOperating] = React.useState([]);
  const [numberInputsOther, setNumberInputsOther] = React.useState([]);
  const [numberInputsPaymentForCost, setNumberInputsPaymentForCost] =
    React.useState([]);
  const [onFocusStartingCash, setOnFocusStartingCash] = React.useState(false);
  const [operatingData, setOperatingData] = React.useState('');
  const [otherData, setOtherData] = React.useState('');
  const [paymentData, setPaymentData] = React.useState('');
  const [pickerValue, setPickerValue] = React.useState('');
  const [reFetch, setReFetch] = React.useState(false);
  const [scenarioTitle, setScenarioTitle] = React.useState('');
  const [selectedIndexCogs, setSelectedIndexCogs] = React.useState([]);
  const [selectedIndexFinance, setSelectedIndexFinance] = React.useState([]);
  const [selectedIndexIncome, setSelectedIndexIncome] = React.useState([]);
  const [selectedIndexOperating, setSelectedIndexOperating] = React.useState(
    []
  );
  const [selectedIndexOther, setSelectedIndexOther] = React.useState([]);
  const [startingCashOn, setStartingCashOn] = React.useState(0);
  const [toggleCreateNew, setToggleCreateNew] = React.useState(false);
  const [totalCashAvailable, setTotalCashAvailable] = React.useState('');
  const [totalCashAvailablePerMonth, setTotalCashAvailablePerMonth] =
    React.useState([]);
  const [totalCashPaidOut, setTotalCashPaidOut] = React.useState([]);
  const [totalFinancePerCategory, setTotalFinancePerCategory] = React.useState(
    []
  );
  const [totalFinancePerMonth, setTotalFinancePerMonth] = React.useState([]);
  const [totalIncomePerCategories, setTotalIncomePerCategories] =
    React.useState([]);
  const [totalIncomePerCategory, setTotalIncomePerCategory] =
    React.useState('');
  const [totalIncomePerMonth, setTotalIncomePerMonth] = React.useState('');
  const [totalOperatingPerCategory, setTotalOperatingPerCategory] =
    React.useState([]);
  const [totalOperatingPerMonth, setTotalOperatingPerMonth] = React.useState(
    []
  );
  const [totalOtherPerCategory, setTotalOtherPerCategory] = React.useState([]);
  const [totalPaymentForCostPerCetagory, setTotalPaymentForCostPerCetagory] =
    React.useState([]);
  const [totalPaymentForCostPerMonth, setTotalPaymentForCostPerMonth] =
    React.useState([]);
  const [usersCategories, setUsersCategories] = React.useState([]);
  const [visibleWhatIf, setVisibleWhatIf] = React.useState(false);
  const calculateBenchmark = arr => {
    const total = arr.reduce((acc, num) => acc + num, 0);

    const percentageArray = arr.map(num => (num / total) * 100);

    return percentageArray;
  };

  const findIndexExpense = (arr, titleObj) => {
    const titleToCompare = titleObj._expense_heads
      ? titleObj._expense_heads.title
      : titleObj.title;

    return arr.findIndex(item => {
      const itemTitle = item._expense_heads
        ? item._expense_heads.title
        : item.title;
      return itemTitle === titleToCompare;
    });
  };

  const getOptions = data => {
    return data.map(item => ({
      label: item.title,
      value: item.id,
    }));
  };

  const prefillNumberExpense = (data, categories, startingDate) => {
    if (!Array.isArray(categories)) {
      console.error('Categories is not an array:', categories);
      return [];
    }

    const startDate = new Date(startingDate);

    if (isNaN(startDate.getTime())) {
      return [];
    }

    const getMonthIndex = (recordMonth, startDate) => {
      const recordDate = new Date(recordMonth);

      if (isNaN(recordDate.getTime())) {
        return -1;
      }

      const monthsDiff =
        (recordDate.getFullYear() - startDate.getFullYear()) * 12 +
        (recordDate.getMonth() - startDate.getMonth());
      return monthsDiff >= 0 ? monthsDiff : -1;
    };

    const defaultCategories = categories.filter(cat => cat.default_value);
    const customCategories = categories.filter(cat => cat.custom_value);

    const defaultNumberInputs = defaultCategories.map(category => {
      const id = category.id;
      const monthArray = Array(12).fill(0);

      const dataItems = data.filter(item => item.user_expense_heads_id === id);

      dataItems.forEach(item => {
        item.data.forEach(record => {
          const monthIndex = getMonthIndex(
            new Date(record.month).toISOString(),
            startDate
          );
          if (monthIndex >= 0 && monthIndex < 12) {
            monthArray[monthIndex] = record.amount || 0;
          }
        });
      });

      return monthArray;
    });

    const customNumberInputs = customCategories.map(category => {
      const id = category.id;
      const monthArray = Array(12).fill(0);

      const dataItems = data.filter(
        item => item.custom_expense_heads_id === id
      );

      dataItems.forEach(item => {
        item.data.forEach(record => {
          const monthIndex = getMonthIndex(
            new Date(record.month).toISOString(),
            startDate
          );
          if (monthIndex >= 0 && monthIndex < 12) {
            monthArray[monthIndex] = record.amount || 0;
          }
        });
      });

      return monthArray;
    });

    return [...defaultNumberInputs, ...customNumberInputs];
  };

  const pullStartingBalance = (data, startingDate) => {
    const result = [];

    let currentDate = new Date(startingDate);
    currentDate.setUTCDate(1);

    for (let i = 0; i < 12; i++) {
      const matchingRecord = data.find(record => {
        const recordDate = new Date(record.month);
        return (
          recordDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
          recordDate.getUTCMonth() === currentDate.getUTCMonth()
        );
      });

      if (matchingRecord) {
        result.push(matchingRecord.amount);
      } else {
        result.push(0);
      }

      currentDate.setUTCMonth(currentDate.getUTCMonth() + 1);
    }

    return result;
  };

  const sortCategoriesExpense = items => {
    const defaultItems = items
      .filter(item => item.default_value === true)
      .sort((a, b) => a.expense_heads_id - b.expense_heads_id);

    const titleCount = {};

    defaultItems.forEach(item => {
      const title = item._expense_heads.title;

      if (titleCount[title]) {
        titleCount[title]++;
        item._expense_heads.title = `${title} ${titleCount[title]}`;
      } else {
        titleCount[title] = 1;
      }
    });

    const customItems = items.filter(item => item.custom_value === true);

    const otherItems = items.filter(
      item => !item.default_value && !item.custom_value
    );

    return [...defaultItems, ...customItems, ...otherItems];
  };

  const totalCashAvailableOverview = (startingCashOnHand, matrices) => {
    const length = matrices[0].length;
    let columnSums = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      for (let j = 0; j < matrices.length; j++) {
        columnSums[i] += matrices[j][i];
      }
    }

    let result = [];

    result[0] = startingCashOnHand + columnSums[0];

    for (let i = 1; i < length; i++) {
      result[i] = result[i - 1] + columnSums[i];
    }

    return result;
  };

  const totalCashPaid = (array1, array2, array3) => {
    const length = array1.length;
    let result = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      result[i] = array1[i] + array2[i] + array3[i];
    }

    return result;
  };

  const totalForCategory = arrays => {
    let result = [];

    for (let i = 0; i < arrays.length; i++) {
      let sum = 0;
      for (let j = 0; j < arrays[i].length; j++) {
        sum += arrays[i][j];
      }
      result.push(sum);
    }

    return result;
  };

  const totalForMonth = arrays => {
    const length = arrays[0].length;
    let result = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      for (let j = 0; j < arrays.length; j++) {
        result[i] += arrays[j][i];
      }
    }

    let totalSum = result.reduce((acc, val) => acc + val, 0);

    result.push(totalSum);

    return result;
  };

  const updateCashOnHands = (cashOnHands, newArray) => {
    cashOnHands.beginning = [...newArray];
    cashOnHands.ending = newArray.slice(1, 13);

    return cashOnHands;
  };

  const updateStartingBalance = (oldValue, newValue, arrayObj) => {
    const difference = newValue - oldValue;

    arrayObj.beginning = arrayObj.beginning.map(num => num + difference);

    arrayObj.ending = arrayObj.beginning.slice(1, 13);

    return arrayObj;
  };

  const updateStartingBalanceWithExpenseChange = (
    oldExpense,
    newExpense,
    arrayObj
  ) => {
    const updatedBeginning = [...arrayObj.beginning];

    for (let i = 0; i < oldExpense.length; i++) {
      const difference = newExpense[i] - oldExpense[i];
      if (difference !== 0) {
        for (let j = i + 1; j < updatedBeginning.length; j++) {
          updatedBeginning[j] -= difference;
        }
        break;
      }
    }

    arrayObj.beginning = updatedBeginning;

    arrayObj.ending = updatedBeginning.slice(1, 13);

    return arrayObj;
  };

  const updateStartingBalanceWithIncomeChange = (
    oldIncome,
    newIncome,
    arrayObj
  ) => {
    // const updatedStartingBalance = [...startingBalance]

    // for (let i = 0; i < oldIncome.length; i++) {
    //     const difference = newIncome[i] - oldIncome[i]
    //     if (difference !== 0) {
    //         for (let j = i + 1; j < updatedStartingBalance.length; j++) {
    //             updatedStartingBalance[j] += difference
    //         }
    //         break
    //     }
    // }

    // return updatedStartingBalance

    const updatedBeginning = [...arrayObj.beginning];

    for (let i = 0; i < oldIncome.length; i++) {
      const difference = newIncome[i] - oldIncome[i];
      if (difference !== 0) {
        for (let j = i + 1; j < updatedBeginning.length; j++) {
          updatedBeginning[j] += difference;
        }
        break;
      }
    }

    arrayObj.beginning = updatedBeginning;

    arrayObj.ending = updatedBeginning.slice(1, 13);

    return arrayObj;
  };
  const defaultAddingExpensesScenarioPOST =
    DefaultApi.useAddingExpensesScenarioPOST();
  const defaultAddingIncomeScenarioPOST =
    DefaultApi.useAddingIncomeScenarioPOST();
  const isFocused = useIsFocused();
  React.useEffect(() => {
    try {
      if (!isFocused) {
        return;
      }
      /* 'Set Variable' action requires configuration: choose a variable */
    } catch (err) {
      console.error(err);
    }
  }, [isFocused]);

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
        },
        dimensions.width
      )}
    >
      {/* Container */}
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <View
            style={StyleSheet.applyWidth(
              {
                flex: { minWidth: Breakpoints.Laptop, value: 1 },
                flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
              },
              dimensions.width
            )}
          >
            <SideMenuBlock
              screen={'whatif'}
              setToggleWhatIf={toggleWhatIf => setVisibleWhatIf(toggleWhatIf)}
              toggleWhatIf={visibleWhatIf}
            />
            {/* What If */}
            <View
              style={StyleSheet.applyWidth(
                { flex: { minWidth: Breakpoints.Laptop, value: 1 } },
                dimensions.width
              )}
            >
              {/* Header */}
              <View>
                <LinearGradient
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)[
                    'Header Linear Gradient'
                  ].props}
                  color1={palettes.Brand['App Blue Dark']}
                  color2={palettes.App['App Blue Light']}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.LinearGradientStyles(theme)[
                        'Header Linear Gradient'
                      ].style,
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {/* Left */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        paddingLeft: {
                          minWidth: Breakpoints.Laptop,
                          value: 24,
                        },
                      },
                      dimensions.width
                    )}
                  />
                  {/* Middle */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 3 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Header'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Header'].style,
                          {
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 22,
                            },
                            paddingBottom: {
                              minWidth: Breakpoints.Laptop,
                              value: 10,
                            },
                            paddingTop: {
                              minWidth: Breakpoints.Laptop,
                              value: 10,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'What If?'}
                      {/* Text 2 */}
                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Header'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Header'].style,
                            {
                              fontSize: {
                                minWidth: Breakpoints.Laptop,
                                value: 22,
                              },
                              paddingBottom: {
                                minWidth: Breakpoints.Laptop,
                                value: 10,
                              },
                              paddingTop: {
                                minWidth: Breakpoints.Laptop,
                                value: 10,
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {' '}
                        {(
                          props.route?.params?.scenario ?? defaultProps.scenario
                        )?.title
                          ? (
                              props.route?.params?.scenario ??
                              defaultProps.scenario
                            )?.title
                          : undefined}
                      </Text>
                    </Text>
                  </View>
                  {/* Right */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'flex-end',
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Laptop,
                          value: 24,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <IconButton
                      onPress={() => {
                        try {
                          navigation.navigate('BestPracticesScreen');
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      color={palettes.Brand.White}
                      icon={'Entypo/help-with-circle'}
                      size={24}
                    />
                  </View>
                </LinearGradient>
              </View>
              {/* Loading View */}
              <>
                {!(isLoading || isFetching) ? null : (
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.App['Black %50'],
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        gap: { minWidth: Breakpoints.Laptop, value: 20 },
                        height: {
                          minWidth: Breakpoints.Laptop,
                          value: dimensions.height,
                        },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        position: {
                          minWidth: Breakpoints.Laptop,
                          value: 'absolute',
                        },
                        width: [
                          {
                            minWidth: Breakpoints.Desktop,
                            value:
                              dimensions.width - dimensions.width * (15 / 100),
                          },
                          {
                            minWidth: Breakpoints.Laptop,
                            value:
                              dimensions.width - dimensions.width * (20 / 100),
                          },
                        ],
                      },
                      dimensions.width
                    )}
                  >
                    <ActivityIndicator
                      animating={true}
                      hidesWhenStopped={true}
                      {...GlobalStyles.ActivityIndicatorStyles(theme)[
                        'Activity Indicator'
                      ].props}
                      size={'large'}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.ActivityIndicatorStyles(theme)[
                          'Activity Indicator'
                        ].style,
                        dimensions.width
                      )}
                    />
                    {/* Message */}
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Header'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Header'].style,
                        dimensions.width
                      )}
                    >
                      {'Loading, please wait...'}
                    </Text>
                  </View>
                )}
              </>
              <>
                {isFetching ? null : (
                  <DefaultApi.FetchGetExpenseHeadsGET
                    handlers={{
                      onData: fetchData => {
                        const handler = async () => {
                          try {
                            /* hidden 'Log to Console' action */
                            if (reFetch) {
                              return;
                            }
                            /* hidden 'Log to Console' action */
                            setIsLoading(true);
                            setSelectedIndexIncome([]);
                            setSelectedIndexCogs([]);
                            setSelectedIndexOperating([]);
                            setSelectedIndexFinance([]);
                            setSelectedIndexOther([]);
                            const incomeHeads = (
                              await DefaultApi.getIncomeHeadsGET(Constants)
                            )?.json;

                            const valuejyByuNvo = sortCategories(
                              (incomeHeads?.income_heads).concat(
                                incomeHeads?.custom_income_heads
                              )
                            );
                            const incCatRes = valuejyByuNvo;
                            setIncomeCategories(valuejyByuNvo);
                            const valueo30H5o7R = fetchData?.cogs;
                            const categoriesPaymentRes = valueo30H5o7R;
                            setAllCategoriesPayment(valueo30H5o7R);
                            const valueO9n8sUgk = sortCategoriesExpense(
                              (fetchData?.operating_expenses).concat(
                                fetchData?.custom_operating_expenses
                              )
                            );
                            const categoriesOperatingRes = valueO9n8sUgk;
                            setAllCategoriesOperating(valueO9n8sUgk);
                            const valueM4ekZyZ9 = sortCategoriesExpense(
                              (fetchData?.finance_expenses).concat(
                                fetchData?.custom_finance_expenses
                              )
                            );
                            const categoriesFinanceRes = valueM4ekZyZ9;
                            setAllCategoriesFinance(valueM4ekZyZ9);
                            const valueYTqzws1z = sortCategoriesExpense(
                              (fetchData?.other_operating_data).concat(
                                fetchData?.custom_other_operating_data
                              )
                            );
                            const categoriesOtherRes = valueYTqzws1z;
                            setAllCategoriesOther(valueYTqzws1z);
                            if (
                              (props.route?.params?.new_or_exist ??
                                defaultProps.new_or_exist) === 'new'
                            ) {
                              const dataRes = (
                                await DefaultApi.getIncomeGET(Constants, {
                                  starting_date: Constants['STARTING_DATE'],
                                })
                              )?.json;

                              const valuehj4jfA62 = [].concat(
                                (dataRes?.default).concat(dataRes?.custom)
                              );
                              const monthlyIncome = valuehj4jfA62;
                              setIncomeData(valuehj4jfA62);
                              const valuensLIWbuU = prefillNumberInputs(
                                monthlyIncome,
                                incCatRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const numberInputsIncomeRes = valuensLIWbuU;
                              setNumberInputsIncome(valuensLIWbuU);
                              const valuetvLoqzI2 = totalForMonth(
                                numberInputsIncomeRes
                              );
                              const total_income_res = valuetvLoqzI2;
                              setTotalIncomePerMonth(valuetvLoqzI2);
                              setTotalIncomePerCategory(
                                totalForCategory(numberInputsIncomeRes)
                              );
                              const resExpense = (
                                await DefaultApi.getExpenseGET(Constants, {
                                  starting_date: Constants['STARTING_DATE'],
                                })
                              )?.json;

                              const valueoRa6RC1z = [].concat(
                                (resExpense?.cogs.default).concat(
                                  resExpense?.cogs.custom
                                )
                              );
                              const monthlyPaymentExpense = valueoRa6RC1z;
                              setPaymentData(valueoRa6RC1z);
                              const valueDySfELU7 = [].concat(
                                (resExpense?.operating_expenses.default).concat(
                                  resExpense?.operating_expenses.custom
                                )
                              );
                              const monthlyOperatingExpense = valueDySfELU7;
                              setOperatingData(valueDySfELU7);
                              const valueRIuL8J5T = [].concat(
                                (resExpense?.finance_expenses.default).concat(
                                  resExpense?.finance_expenses.custom
                                )
                              );
                              const monthlyFinanceExpense = valueRIuL8J5T;
                              setFinanceData(valueRIuL8J5T);
                              const valueyXGtudX6 = [].concat(
                                (resExpense?.other_operating_data.default).concat(
                                  resExpense?.other_operating_data.custom
                                )
                              );
                              const monthlyOtherExpense = valueyXGtudX6;
                              setOtherData(valueyXGtudX6);
                              const valueubwxEpRd = prefillNumberExpense(
                                monthlyPaymentExpense,
                                categoriesPaymentRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niPaymentRes = valueubwxEpRd;
                              setNumberInputsPaymentForCost(valueubwxEpRd);
                              const valuetjZ0cSxs = prefillNumberExpense(
                                monthlyOperatingExpense,
                                categoriesOperatingRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niOperatingRes = valuetjZ0cSxs;
                              setNumberInputsOperating(valuetjZ0cSxs);
                              const valuekkGOL1Gf = prefillNumberExpense(
                                monthlyFinanceExpense,
                                categoriesFinanceRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niFinanceRes = valuekkGOL1Gf;
                              setNumberInputsFinance(valuekkGOL1Gf);
                              const valuetNcar6kH = prefillNumberExpense(
                                monthlyOtherExpense,
                                categoriesOtherRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niOtherRes = valuetNcar6kH;
                              setNumberInputsOther(valuetNcar6kH);
                              const valuetgcwO6r2 = totalForMonth(niPaymentRes);
                              const paymentPerMonth = valuetgcwO6r2;
                              setTotalPaymentForCostPerMonth(valuetgcwO6r2);
                              setTotalPaymentForCostPerCetagory(
                                totalForCategory(niPaymentRes)
                              );

                              const valueBaPcoWIQ =
                                totalForMonth(niOperatingRes);
                              const operatingPerMonth = valueBaPcoWIQ;
                              setTotalOperatingPerMonth(valueBaPcoWIQ);
                              setTotalOperatingPerCategory(
                                totalForCategory(niOperatingRes)
                              );
                              setTotalFinancePerCategory(
                                totalForCategory(niFinanceRes)
                              );
                              setTotalFinancePerMonth(
                                totalForMonth(niFinanceRes)
                              );
                              setTotalOtherPerCategory(
                                totalForCategory(niOtherRes)
                              );

                              const valueNNjH23Wl = totalCashPaid(
                                totalForMonth(niPaymentRes),
                                totalForMonth(niOperatingRes),
                                totalForMonth(niFinanceRes)
                              );
                              const total_cash_paid_out = valueNNjH23Wl;
                              setTotalCashPaidOut(valueNNjH23Wl);
                              const valuekLeX6yMx = updateCashOnHands(
                                cashOnHands,
                                pullStartingBalance(
                                  dataRes?.cash_at_hand,
                                  Constants['STARTING_DATE']
                                ).concat([
                                  (total_income_res && total_income_res[11]) -
                                    (total_cash_paid_out &&
                                      total_cash_paid_out[11]) +
                                    (pullStartingBalance(
                                      dataRes?.cash_at_hand,
                                      Constants['STARTING_DATE']
                                    ) &&
                                      pullStartingBalance(
                                        dataRes?.cash_at_hand,
                                        Constants['STARTING_DATE']
                                      )[11]),
                                ])
                              );
                              const new_monthly_cash_on_hand = valuekLeX6yMx;
                              setCashOnHands(valuekLeX6yMx);
                              const valuehefQUk5R =
                                new_monthly_cash_on_hand?.beginning &&
                                (new_monthly_cash_on_hand?.beginning)[0];
                              const starting_cash = valuehefQUk5R;
                              setStartingCashOn(valuehefQUk5R);
                              setTotalCashAvailable(
                                sumArrays(
                                  total_income_res,
                                  new_monthly_cash_on_hand?.beginning
                                ).slice(0, 12)
                              );
                            } else {
                              const dataRes2 = (
                                await DefaultApi.getScenarioIncomeGET(
                                  Constants,
                                  {
                                    scenario_id:
                                      props.route?.params?.exist_scenario_id ??
                                      defaultProps.exist_scenario_id,
                                    starting_date: Constants['STARTING_DATE'],
                                  }
                                )
                              )?.json;

                              const valueapZKJ0Ab =
                                dataRes2?.cash_at_hand?.[0]?.amount;
                              const starting_cash2 = valueapZKJ0Ab;
                              setStartingCashOn(valueapZKJ0Ab);
                              const valueVqb0ZQ6y = [].concat(
                                (dataRes2?.default).concat(dataRes2?.custom)
                              );
                              const monthlyIncome2 = valueVqb0ZQ6y;
                              setIncomeData(valueVqb0ZQ6y);
                              const valueJ8DyEOhY = prefillNumberInputs(
                                monthlyIncome2,
                                incCatRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const numberInputsIncomeRes2 = valueJ8DyEOhY;
                              setNumberInputsIncome(valueJ8DyEOhY);
                              const valueOxMN1KWG = totalForMonth(
                                numberInputsIncomeRes2
                              );
                              const total_income_res2 = valueOxMN1KWG;
                              setTotalIncomePerMonth(valueOxMN1KWG);
                              setTotalIncomePerCategory(
                                totalForCategory(numberInputsIncomeRes2)
                              );
                              const resExpense2 = (
                                await DefaultApi.getScenarioExpenseGET(
                                  Constants,
                                  {
                                    scenario_id:
                                      props.route?.params?.exist_scenario_id ??
                                      defaultProps.exist_scenario_id,
                                    starting_date: Constants['STARTING_DATE'],
                                  }
                                )
                              )?.json;

                              const value444zcPbz = [].concat(
                                (resExpense2?.cogs?.default).concat(
                                  resExpense2?.cogs.custom
                                )
                              );
                              const monthlyPaymentExpense2 = value444zcPbz;
                              setPaymentData(value444zcPbz);
                              const valuek3y5UxK0 = [].concat(
                                (resExpense2?.operating_expenses.default).concat(
                                  resExpense2?.operating_expenses.custom
                                )
                              );
                              const monthlyOperatingExpense2 = valuek3y5UxK0;
                              setOperatingData(valuek3y5UxK0);
                              const valueGO8AqQWQ = [].concat(
                                (resExpense2?.finance_expenses.default).concat(
                                  resExpense2?.finance_expenses.custom
                                )
                              );
                              const monthlyFinanceExpense2 = valueGO8AqQWQ;
                              setFinanceData(valueGO8AqQWQ);
                              const valueYqHuIZx8 = [].concat(
                                (resExpense2?.other_operating_data.default).concat(
                                  resExpense2?.other_operating_data.custom
                                )
                              );
                              const monthlyOtherExpense2 = valueYqHuIZx8;
                              setOtherData(valueYqHuIZx8);
                              const valueKJxaXZgB = prefillNumberExpense(
                                monthlyPaymentExpense2,
                                categoriesPaymentRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niPaymentRes2 = valueKJxaXZgB;
                              setNumberInputsPaymentForCost(valueKJxaXZgB);
                              const valueHgS53pj3 = prefillNumberExpense(
                                monthlyOperatingExpense2,
                                categoriesOperatingRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niOperatingRes2 = valueHgS53pj3;
                              setNumberInputsOperating(valueHgS53pj3);
                              const valueN0J8dwxn = prefillNumberExpense(
                                monthlyFinanceExpense2,
                                categoriesFinanceRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niFinanceRes2 = valueN0J8dwxn;
                              setNumberInputsFinance(valueN0J8dwxn);
                              const valueU5qDAFRZ = prefillNumberExpense(
                                monthlyOtherExpense2,
                                categoriesOtherRes,
                                timestampToISO(Constants['STARTING_DATE'])
                              );
                              const niOtherRes2 = valueU5qDAFRZ;
                              setNumberInputsOther(valueU5qDAFRZ);
                              const valueDZtP8TIL =
                                totalForMonth(niPaymentRes2);
                              const paymentPerMonth2 = valueDZtP8TIL;
                              setTotalPaymentForCostPerMonth(valueDZtP8TIL);
                              setTotalPaymentForCostPerCetagory(
                                totalForCategory(niPaymentRes2)
                              );

                              const valueV3MHg7B6 =
                                totalForMonth(niOperatingRes2);
                              const operatingPerMonth2 = valueV3MHg7B6;
                              setTotalOperatingPerMonth(valueV3MHg7B6);
                              setTotalOperatingPerCategory(
                                totalForCategory(niOperatingRes2)
                              );
                              setTotalFinancePerCategory(
                                totalForCategory(niFinanceRes2)
                              );
                              setTotalFinancePerMonth(
                                totalForMonth(niFinanceRes2)
                              );
                              setTotalOtherPerCategory(
                                totalForCategory(niOtherRes2)
                              );

                              const valueTmxsVO8L = totalCashPaid(
                                totalForMonth(niPaymentRes2),
                                totalForMonth(niOperatingRes2),
                                totalForMonth(niFinanceRes2)
                              );
                              const total_cash_paid_out2 = valueTmxsVO8L;
                              setTotalCashPaidOut(valueTmxsVO8L);
                              const value75MGDwev = calculateCashOnHandFlow(
                                total_income_res2.slice(0, 12),
                                total_cash_paid_out2.slice(0, 12),
                                starting_cash2
                              );
                              const monthly_cash_on_hand2 = value75MGDwev;
                              setCashOnHands(value75MGDwev);
                              setTotalCashAvailable(
                                sumArrays(
                                  total_income_res2,
                                  monthly_cash_on_hand2?.beginning
                                ).slice(0, 12)
                              );
                            }

                            setIsLoading(false);
                            setReFetch(true);
                            /* hidden 'Log to Console' action */
                          } catch (err) {
                            console.error(err);
                          }
                        };
                        handler();
                      },
                    }}
                  >
                    {({ loading, error, data, refetchGetExpenseHeads }) => {
                      const fetchData = data?.json;
                      if (loading) {
                        return <View />;
                      }

                      if (error || data?.status < 200 || data?.status >= 300) {
                        return <ActivityIndicator />;
                      }

                      return (
                        <>
                          {isLoading ? null : (
                            <SimpleStyleScrollView
                              bounces={true}
                              horizontal={false}
                              keyboardShouldPersistTaps={'never'}
                              nestedScrollEnabled={false}
                              showsHorizontalScrollIndicator={true}
                              showsVerticalScrollIndicator={true}
                              style={StyleSheet.applyWidth(
                                {
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: Constants['SWITCH_SCREEN_MODE']
                                      ? palettes.Brand.White
                                      : palettes.Brand.Background,
                                  },
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 10,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              {/* Bar/Line Chart */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.App['App Blue Light'],
                                    },
                                    borderWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 3,
                                    },
                                    marginTop: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 20,
                                    },
                                    maxHeight: {
                                      minWidth: Breakpoints.Laptop,
                                      value: '40%',
                                    },
                                    paddingLeft: {
                                      minWidth: Breakpoints.Laptop,
                                      value: '5%',
                                    },
                                    paddingRight: {
                                      minWidth: Breakpoints.Laptop,
                                      value: '5%',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <LinearGradient
                                  endX={100}
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  color1={StyleSheet.getWidthValue(
                                    [
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value:
                                          palettes.App['Gray Linear Light'],
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.App['Background Light'],
                                      },
                                    ],
                                    dimensions.width
                                  )}
                                  color2={StyleSheet.getWidthValue(
                                    [
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value: palettes.App['Gray Linear Dark'],
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.Background,
                                      },
                                    ],
                                    dimensions.width
                                  )}
                                  color3={StyleSheet.getWidthValue(
                                    [
                                      {
                                        minWidth: Breakpoints.Mobile,
                                        value:
                                          palettes.App['Gray Linear Light'],
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.App['Background Light'],
                                      },
                                    ],
                                    dimensions.width
                                  )}
                                  style={StyleSheet.applyWidth(
                                    {
                                      bottom: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 0,
                                      },
                                      left: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 0,
                                      },
                                      position: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'absolute',
                                      },
                                      right: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 0,
                                      },
                                      top: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 0,
                                      },
                                    },
                                    dimensions.width
                                  )}
                                />
                                {/* Header */}
                                <View
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      alignSelf: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      backgroundColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand['App Blue Dark'],
                                      },
                                      borderColor: {
                                        minWidth: Breakpoints.Laptop,
                                        value:
                                          palettes.App['Gray Linear Light'],
                                      },
                                      borderWidth: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 3,
                                      },
                                      justifyContent: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      marginTop: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 5,
                                      },
                                      padding: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 4,
                                      },
                                      position: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'absolute',
                                      },
                                      zIndex: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 5,
                                      },
                                    },
                                    dimensions.width
                                  )}
                                >
                                  <LinearGradient
                                    color1={theme.colors.branding.primary}
                                    color2={theme.colors.branding.secondary}
                                    endY={100}
                                    startX={0}
                                    startY={0}
                                    {...GlobalStyles.LinearGradientStyles(
                                      theme
                                    )['Blue Linear'].props}
                                    endX={0}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.LinearGradientStyles(
                                          theme
                                        )['Blue Linear'].style,
                                        {
                                          paddingBottom: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 0,
                                          },
                                          paddingTop: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 0,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {/* Header Text */}
                                    <Text
                                      accessible={true}
                                      selectable={false}
                                      {...GlobalStyles.TextStyles(theme)['Text']
                                        .props}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.TextStyles(theme)['Text']
                                            .style,
                                          {
                                            color: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.Black,
                                            },
                                            fontFamily: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'OpenSans_700Bold',
                                            },
                                            fontSize: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 12,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {'Cash On hand vs. Expenses'}
                                    </Text>
                                  </LinearGradient>
                                </View>
                                <Utils.CustomCodeErrorBoundary>
                                  <BarChartWhatIf.App
                                    totalCashPaid={totalCashPaidOut}
                                    cashOnHand={cashOnHands}
                                  />
                                </Utils.CustomCodeErrorBoundary>
                                {/* Chart Materials View */}
                                <View
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      gap: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 6,
                                      },
                                      height: {
                                        minWidth: Breakpoints.Laptop,
                                        value: '100%',
                                      },
                                      justifyContent: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      position: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'absolute',
                                      },
                                      right: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 0,
                                      },
                                      width: {
                                        minWidth: Breakpoints.Laptop,
                                        value: '10%',
                                      },
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Total Cash Paid Out */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        alignItems: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'center',
                                        },
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                        gap: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 4,
                                        },
                                        width: {
                                          minWidth: Breakpoints.Laptop,
                                          value: '100%',
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    <Icon
                                      color={palettes.Brand['App Blue Dark']}
                                      name={'Ionicons/square-sharp'}
                                      size={14}
                                    />
                                    <Text
                                      accessible={true}
                                      selectable={false}
                                      {...GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].props}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text White'
                                          ].style,
                                          {
                                            color: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '"rgb(255, 255, 255)"',
                                            },
                                            textAlign: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'left',
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {'Total Cash Paid Out'}
                                    </Text>
                                  </View>
                                  {/* Cash on hand */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        alignItems: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'center',
                                        },
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                        gap: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 4,
                                        },
                                        width: {
                                          minWidth: Breakpoints.Laptop,
                                          value: '100%',
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    <Icon
                                      color={palettes.Brand['App Green']}
                                      name={'Ionicons/square-sharp'}
                                      size={14}
                                    />
                                    <Text
                                      accessible={true}
                                      selectable={false}
                                      {...GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].props}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text White'
                                          ].style,
                                          {
                                            color: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '"rgb(255, 255, 255)"',
                                            },
                                            textAlign: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'left',
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {'Cash on hand (end of month)'}
                                    </Text>
                                  </View>
                                </View>
                              </View>
                              {/* Middle Info View */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'space-evenly',
                                    },
                                    paddingBottom: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 10,
                                    },
                                    paddingTop: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 10,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Starting Cash On */}
                                <View
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      flexDirection: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'row',
                                      },
                                      gap: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 12,
                                      },
                                    },
                                    dimensions.width
                                  )}
                                >
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: {
                                            minWidth: Breakpoints.Laptop,
                                            value: checkScreenMode(Variables)
                                              ? palettes.Brand.White
                                              : palettes.Brand.Black,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Starting cash on hand'}
                                  </Text>

                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        borderColor: [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: palettes.Brand.White,
                                          },
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: Constants[
                                              'SWITCH_SCREEN_MODE'
                                            ]
                                              ? palettes.Brand.Black
                                              : palettes.App['Custom White'],
                                          },
                                        ],
                                        borderWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 1,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    <NumberInput
                                      changeTextDelay={500}
                                      onBlur={() => {
                                        try {
                                          setOnFocusStartingCash(false);
                                        } catch (err) {
                                          console.error(err);
                                        }
                                      }}
                                      onChangeText={newNumberInputValue => {
                                        try {
                                          setStartingCashOn(
                                            newNumberInputValue
                                          );
                                          if (
                                            (props.route?.params
                                              ?.new_or_exist ??
                                              defaultProps.new_or_exist) ===
                                            'new'
                                          ) {
                                            const valueoZllu9u0 =
                                              updateStartingBalance(
                                                startingCashOn,
                                                newNumberInputValue,
                                                cashOnHands
                                              );
                                            const new_cash_on_hand =
                                              valueoZllu9u0;
                                            setCashOnHands(valueoZllu9u0);
                                            setTotalCashAvailable(
                                              sumArrays(
                                                new_cash_on_hand?.beginning,
                                                totalIncomePerMonth
                                              ).slice(0, 12)
                                            );
                                          } else {
                                            const valueRkwqOs69 =
                                              calculateCashOnHandFlow(
                                                totalIncomePerMonth.slice(
                                                  0,
                                                  12
                                                ),
                                                totalCashPaidOut.slice(0, 12),
                                                newNumberInputValue
                                              );
                                            const cash_on_hand = valueRkwqOs69;
                                            setCashOnHands(valueRkwqOs69);
                                            setTotalCashAvailable(
                                              sumArrays(
                                                (cash_on_hand?.beginning).slice(
                                                  0,
                                                  12
                                                ),
                                                totalIncomePerMonth
                                              ).slice(0, 12)
                                            );
                                          }
                                        } catch (err) {
                                          console.error(err);
                                        }
                                      }}
                                      onFocus={() => {
                                        try {
                                          setOnFocusStartingCash(true);
                                        } catch (err) {
                                          console.error(err);
                                        }
                                      }}
                                      webShowOutline={true}
                                      {...GlobalStyles.NumberInputStyles(theme)[
                                        'Table Number Input'
                                      ].props}
                                      placeholder={''}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.NumberInputStyles(theme)[
                                            'Table Number Input'
                                          ].style,
                                          {
                                            color: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.White,
                                              },
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: !onFocusStartingCash
                                                  ? palettes.Brand.Transparent
                                                  : Constants[
                                                      'SWITCH_SCREEN_MODE'
                                                    ]
                                                  ? palettes.Brand.Black
                                                  : palettes.Brand.White,
                                              },
                                            ],
                                            paddingBottom: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 4,
                                            },
                                            paddingTop: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 4,
                                            },
                                            textAlign: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'right',
                                            },
                                            zIndex: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                      value={startingCashOn}
                                    />
                                    {/* Format View */}
                                    <>
                                      {onFocusStartingCash ? null : (
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'space-between',
                                              },
                                              paddingLeft: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 4,
                                              },
                                              paddingRight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 4,
                                              },
                                              position: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'absolute',
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                              zIndex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 0,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* $ */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  color: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: Constants[
                                                      'SWITCH_SCREEN_MODE'
                                                    ]
                                                      ? palettes.Brand.Black
                                                      : palettes.Brand.White,
                                                  },
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value:
                                                      'OpenSans_600SemiBold',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 10,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                          </Text>
                                          {/* Number Value */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  color: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: Constants[
                                                      'SWITCH_SCREEN_MODE'
                                                    ]
                                                      ? palettes.Brand.Black
                                                      : palettes.Brand.White,
                                                  },
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value:
                                                      'OpenSans_600SemiBold',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 10,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {formatNumber(startingCashOn)}
                                          </Text>
                                        </View>
                                      )}
                                    </>
                                  </View>
                                </View>
                                {/* Starting Date */}
                                <View
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      flexDirection: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'row',
                                      },
                                      gap: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 12,
                                      },
                                    },
                                    dimensions.width
                                  )}
                                >
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: {
                                            minWidth: Breakpoints.Laptop,
                                            value: checkScreenMode(Variables)
                                              ? palettes.Brand.White
                                              : palettes.Brand.Black,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Starting Date'}
                                  </Text>

                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        borderColor: [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: palettes.Brand.White,
                                          },
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: checkScreenMode(Variables)
                                              ? palettes.Brand.White
                                              : palettes.Brand.Black,
                                          },
                                        ],
                                        borderWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 1,
                                        },
                                        padding: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 4,
                                        },
                                        paddingLeft: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 12,
                                        },
                                        paddingRight: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 12,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Value */}
                                    <Text
                                      accessible={true}
                                      selectable={false}
                                      {...GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].props}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text White'
                                          ].style,
                                          {
                                            color: {
                                              minWidth: Breakpoints.Laptop,
                                              value: checkScreenMode(Variables)
                                                ? palettes.Brand.White
                                                : palettes.Brand.Black,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {DateUtils.format(
                                        DateUtils.addDays(
                                          Constants['STARTING_DATE'],
                                          1
                                        ),
                                        'MMM YYYY'
                                      )}
                                    </Text>
                                  </View>
                                </View>
                                {/* Cash Minimum Balance Alert */}
                                <View
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'center',
                                      },
                                      flexDirection: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'row',
                                      },
                                      gap: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 12,
                                      },
                                    },
                                    dimensions.width
                                  )}
                                >
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      StyleSheet.compose(
                                        GlobalStyles.TextStyles(theme)[
                                          'Chart Text White'
                                        ].style,
                                        {
                                          color: {
                                            minWidth: Breakpoints.Laptop,
                                            value: checkScreenMode(Variables)
                                              ? palettes.Brand.White
                                              : palettes.Brand.Black,
                                          },
                                        }
                                      ),
                                      dimensions.width
                                    )}
                                  >
                                    {'Cash minmum balance alert'}
                                  </Text>

                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        borderColor: [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: palettes.Brand.White,
                                          },
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: checkScreenMode(Variables)
                                              ? palettes.Brand.White
                                              : palettes.Brand.Black,
                                          },
                                        ],
                                        borderWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 1,
                                        },
                                        padding: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 4,
                                        },
                                        paddingLeft: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 12,
                                        },
                                        paddingRight: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 12,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Value */}
                                    <Text
                                      accessible={true}
                                      selectable={false}
                                      {...GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].props}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text White'
                                          ].style,
                                          {
                                            color: {
                                              minWidth: Breakpoints.Laptop,
                                              value: checkScreenMode(Variables)
                                                ? palettes.Brand.White
                                                : palettes.Brand.Black,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {'$ '}
                                      {formatNumber(
                                        Constants['USER_DETAILS']
                                          ?._profile_of_user?.cash_min_balance
                                      )}
                                    </Text>
                                  </View>
                                </View>
                              </View>

                              <SimpleStyleScrollView
                                bounces={true}
                                keyboardShouldPersistTaps={'never'}
                                nestedScrollEnabled={false}
                                showsHorizontalScrollIndicator={true}
                                showsVerticalScrollIndicator={true}
                                horizontal={true}
                                style={StyleSheet.applyWidth(
                                  {
                                    paddingBottom: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 20,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Table */}
                                <View>
                                  {/* Header 1 */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                        height: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 25,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Month */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            maxWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* Month */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'Month'}
                                      </Text>
                                    </LinearGradient>
                                    {/* Months List */}
                                    <SimpleStyleFlatList
                                      data={generateDates(
                                        Constants['STARTING_DATE']
                                      )
                                        .concat('Ending Balance')
                                        .concat('%')}
                                      decelerationRate={'normal'}
                                      inverted={false}
                                      keyExtractor={(monthsListData, index) =>
                                        monthsListData?.id ??
                                        monthsListData?.uuid ??
                                        index?.toString() ??
                                        JSON.stringify(monthsListData)
                                      }
                                      keyboardShouldPersistTaps={'never'}
                                      listKey={'nesFlGRq'}
                                      nestedScrollEnabled={false}
                                      numColumns={1}
                                      onEndReachedThreshold={0.5}
                                      pagingEnabled={false}
                                      renderItem={({ item, index }) => {
                                        const monthsListData = item;
                                        return (
                                          <>
                                            {/* Months Gradient */}
                                            <LinearGradient
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              color1={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              color2={
                                                palettes.App['App Blue Light']
                                              }
                                              color3={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderBottomWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderLeftWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 75,
                                                    },
                                                    width: [
                                                      {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value:
                                                          (dimensions.width -
                                                            dimensions.width *
                                                              (15 / 100) -
                                                            320) /
                                                          14,
                                                      },
                                                    ],
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {/* Months Text */}
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  dimensions.width
                                                )}
                                              >
                                                {monthsListData}
                                              </Text>
                                            </LinearGradient>
                                          </>
                                        );
                                      }}
                                      showsVerticalScrollIndicator={true}
                                      snapToAlignment={'start'}
                                      horizontal={true}
                                      scrollEnabled={false}
                                      showsHorizontalScrollIndicator={false}
                                    />
                                  </View>
                                  {/* Header 2 */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                        height: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 25,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Cash On Hand (begining of the month) */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            maxWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* Cash On Hand (begining of the month) */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'Cash on hand (begining of the month)'}
                                      </Text>
                                    </LinearGradient>
                                    {/* Cash On Hand List */}
                                    <SimpleStyleFlatList
                                      data={(cashOnHands?.beginning).concat([
                                        '',
                                      ])}
                                      decelerationRate={'normal'}
                                      inverted={false}
                                      keyExtractor={(
                                        cashOnHandListData,
                                        index
                                      ) =>
                                        cashOnHandListData?.id ??
                                        cashOnHandListData?.uuid ??
                                        index?.toString() ??
                                        JSON.stringify(cashOnHandListData)
                                      }
                                      keyboardShouldPersistTaps={'never'}
                                      listKey={'zdI8ZqV9'}
                                      nestedScrollEnabled={false}
                                      numColumns={1}
                                      onEndReachedThreshold={0.5}
                                      pagingEnabled={false}
                                      renderItem={({ item, index }) => {
                                        const cashOnHandListData = item;
                                        return (
                                          <>
                                            {/* Cash On Hand */}
                                            <LinearGradient
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              color1={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              color2={
                                                palettes.App['App Blue Light']
                                              }
                                              color3={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderBottomWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderLeftWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 75,
                                                    },
                                                    width: [
                                                      {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value:
                                                          (dimensions.width -
                                                            dimensions.width *
                                                              (15 / 100) -
                                                            320) /
                                                          14,
                                                      },
                                                    ],
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {/* $ */}
                                              <>
                                                {!(index < 12) ? null : (
                                                  <Text
                                                    accessible={true}
                                                    selectable={false}
                                                    {...GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text'].props}
                                                    style={StyleSheet.applyWidth(
                                                      GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text'].style,
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {'$'}
                                                  </Text>
                                                )}
                                              </>
                                              {/* Value */}
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  dimensions.width
                                                )}
                                              >
                                                {index < 13
                                                  ? formatNumber(
                                                      cashOnHandListData
                                                    )
                                                  : cashOnHandListData}
                                              </Text>
                                            </LinearGradient>
                                          </>
                                        );
                                      }}
                                      showsHorizontalScrollIndicator={true}
                                      showsVerticalScrollIndicator={true}
                                      snapToAlignment={'start'}
                                      horizontal={true}
                                      scrollEnabled={false}
                                    />
                                  </View>
                                  {/* Table Main */}
                                  <View>
                                    {/* Fetch Loaded */}
                                    <View>
                                      {/* Income */}
                                      <View>
                                        {/* Header View */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              padding: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 6,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Income Header */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Header'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Header'
                                                ].style,
                                                {
                                                  color: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: checkScreenMode(
                                                      Variables
                                                    )
                                                      ? palettes.Brand.White
                                                      : palettes.Brand.Black,
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 18,
                                                  },
                                                  textAlign: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'right',
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Income'}
                                          </Text>
                                        </View>
                                        {/* Categories */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              borderTopWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Left */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                backgroundColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: checkScreenMode(
                                                    Variables
                                                  )
                                                    ? undefined
                                                    : palettes.Brand.White,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Categories List */}
                                            <SimpleStyleFlatList
                                              data={incomeCategories}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                categoriesListData,
                                                index
                                              ) =>
                                                categoriesListData?.id ??
                                                categoriesListData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(
                                                  categoriesListData
                                                )
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'Sl1vKqt7'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const categoriesListData = item;
                                                return (
                                                  <>
                                                    {/* Categories */}
                                                    <View
                                                      style={StyleSheet.applyWidth(
                                                        {
                                                          flexDirection: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 'row',
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: '100%',
                                                          },
                                                        },
                                                        dimensions.width
                                                      )}
                                                    >
                                                      <LinearGradient
                                                        endY={100}
                                                        color1={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Light'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        }
                                                        color2={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        }
                                                        endX={0}
                                                        startX={0}
                                                        startY={0}
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            alignItems: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            borderBottomWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .Black,
                                                            },
                                                            borderLeftWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            borderRightWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            flexDirection: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'row',
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'flex-end',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            maxWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Categories Text */}
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .props}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].style,
                                                              {
                                                                color: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    checkScreenMode(
                                                                      Variables
                                                                    )
                                                                      ? palettes
                                                                          .Brand
                                                                          .White
                                                                      : palettes
                                                                          .Brand
                                                                          .Black,
                                                                },
                                                                paddingLeft: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 4,
                                                                },
                                                                paddingRight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 4,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {categoriesListData?.default_value
                                                            ? categoriesListData
                                                                ?._income_heads
                                                                ?.title
                                                            : categoriesListData?.title}
                                                        </Text>
                                                      </LinearGradient>
                                                      {/* Matrix List */}
                                                      <SimpleStyleFlatList
                                                        data={[
                                                          1, 2, 3, 4, 5, 6, 7,
                                                          8, 9, 10, 11, 12,
                                                        ]}
                                                        decelerationRate={
                                                          'normal'
                                                        }
                                                        inverted={false}
                                                        keyExtractor={(
                                                          matrixListData,
                                                          index
                                                        ) =>
                                                          matrixListData?.id ??
                                                          matrixListData?.uuid ??
                                                          index?.toString() ??
                                                          JSON.stringify(
                                                            matrixListData
                                                          )
                                                        }
                                                        keyboardShouldPersistTaps={
                                                          'never'
                                                        }
                                                        listKey={JSON.stringify(
                                                          [
                                                            1, 2, 3, 4, 5, 6, 7,
                                                            8, 9, 10, 11, 12,
                                                          ]
                                                        )}
                                                        nestedScrollEnabled={
                                                          false
                                                        }
                                                        numColumns={1}
                                                        onEndReachedThreshold={
                                                          0.5
                                                        }
                                                        pagingEnabled={false}
                                                        renderItem={({
                                                          item,
                                                          index,
                                                        }) => {
                                                          const matrixListData =
                                                            item;
                                                          return (
                                                            <LinearGradient
                                                              endY={100}
                                                              startX={0}
                                                              startY={0}
                                                              color1={
                                                                (checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .Background
                                                                  : palettes
                                                                      .App[
                                                                      'Light Linear - Dark'
                                                                    ]) ??
                                                                theme.colors
                                                                  .branding
                                                                  .primary
                                                              }
                                                              color2={
                                                                (checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .App[
                                                                      'Gray Linear Dark'
                                                                    ]
                                                                  : palettes
                                                                      .App[
                                                                      'Light Linear - Light'
                                                                    ]) ??
                                                                theme.colors
                                                                  .branding
                                                                  .secondary
                                                              }
                                                              color3={
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .Background
                                                                  : palettes
                                                                      .App[
                                                                      'Light Linear - Dark'
                                                                    ]
                                                              }
                                                              endX={0}
                                                              style={StyleSheet.applyWidth(
                                                                {
                                                                  alignItems: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'center',
                                                                  },
                                                                  borderBottomWidth:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 1,
                                                                    },
                                                                  borderColor: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      palettes
                                                                        .Brand
                                                                        .Black,
                                                                  },
                                                                  borderRightWidth:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 1,
                                                                    },
                                                                  height: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 25,
                                                                  },
                                                                  justifyContent:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        'center',
                                                                    },
                                                                  maxHeight: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 25,
                                                                  },
                                                                  minHeight: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 25,
                                                                  },
                                                                  minWidth: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 75,
                                                                  },
                                                                  width: [
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 75,
                                                                    },
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.BigScreen,
                                                                      value:
                                                                        (dimensions.width -
                                                                          dimensions.width *
                                                                            (15 /
                                                                              100) -
                                                                          320) /
                                                                        14,
                                                                    },
                                                                  ],
                                                                },
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {/* Matrix Input */}
                                                              <NumberInput
                                                                changeTextDelay={
                                                                  500
                                                                }
                                                                onBlur={() => {
                                                                  try {
                                                                    setSelectedIndexIncome(
                                                                      addOrRemove(
                                                                        selectedIndexIncome,
                                                                        index,
                                                                        findIndextAllCategories(
                                                                          incomeCategories,
                                                                          categoriesListData
                                                                        )
                                                                      )
                                                                    );
                                                                  } catch (err) {
                                                                    console.error(
                                                                      err
                                                                    );
                                                                  }
                                                                }}
                                                                onChangeText={newMatrixInputValue => {
                                                                  try {
                                                                    console.log(
                                                                      'collumn index',
                                                                      index,
                                                                      'row index',
                                                                      findIndextAllCategories(
                                                                        sortCategories(
                                                                          incomeCategories
                                                                        ),
                                                                        categoriesListData
                                                                      )
                                                                    );
                                                                    const resIncome =
                                                                      updateTableRows(
                                                                        index,
                                                                        findIndextAllCategories(
                                                                          incomeCategories,
                                                                          categoriesListData
                                                                        ),
                                                                        newMatrixInputValue >=
                                                                          0
                                                                          ? newMatrixInputValue
                                                                          : 0,
                                                                        numberInputsIncome
                                                                      );
                                                                    setTotalIncomePerCategory(
                                                                      totalForCategory(
                                                                        resIncome
                                                                      )
                                                                    );

                                                                    const valueV4YwBsjV =
                                                                      totalForMonth(
                                                                        resIncome
                                                                      );
                                                                    const total_income =
                                                                      valueV4YwBsjV;
                                                                    setTotalIncomePerMonth(
                                                                      valueV4YwBsjV
                                                                    );
                                                                    if (
                                                                      (props
                                                                        .route
                                                                        ?.params
                                                                        ?.new_or_exist ??
                                                                        defaultProps.new_or_exist) ===
                                                                      'new'
                                                                    ) {
                                                                      const valueuU7mWLHl =
                                                                        updateStartingBalanceWithIncomeChange(
                                                                          totalIncomePerMonth,
                                                                          total_income,
                                                                          cashOnHands
                                                                        );
                                                                      const new_cash_on_hand =
                                                                        valueuU7mWLHl;
                                                                      setCashOnHands(
                                                                        valueuU7mWLHl
                                                                      );
                                                                      setTotalCashAvailable(
                                                                        sumArrays(
                                                                          new_cash_on_hand?.beginning,
                                                                          total_income
                                                                        ).slice(
                                                                          0,
                                                                          12
                                                                        )
                                                                      );
                                                                    } else {
                                                                      const valuebvvi8srX =
                                                                        calculateCashOnHandFlow(
                                                                          total_income,
                                                                          totalCashPaidOut,
                                                                          startingCashOn
                                                                        );
                                                                      const cash_on_hand =
                                                                        valuebvvi8srX;
                                                                      setCashOnHands(
                                                                        valuebvvi8srX
                                                                      );
                                                                      setTotalCashAvailable(
                                                                        sumArrays(
                                                                          total_income,
                                                                          cash_on_hand?.beginning
                                                                        ).slice(
                                                                          0,
                                                                          12
                                                                        )
                                                                      );
                                                                    }
                                                                  } catch (err) {
                                                                    console.error(
                                                                      err
                                                                    );
                                                                  }
                                                                }}
                                                                onFocus={() => {
                                                                  try {
                                                                    setSelectedIndexIncome(
                                                                      addOrRemove(
                                                                        selectedIndexIncome,
                                                                        index,
                                                                        findIndextAllCategories(
                                                                          incomeCategories,
                                                                          categoriesListData
                                                                        )
                                                                      )
                                                                    );
                                                                  } catch (err) {
                                                                    console.error(
                                                                      err
                                                                    );
                                                                  }
                                                                }}
                                                                {...GlobalStyles.NumberInputStyles(
                                                                  theme
                                                                )[
                                                                  'Table Number Input'
                                                                ].props}
                                                                defaultValue={getInitValue(
                                                                  numberInputsIncome,
                                                                  findIndextAllCategories(
                                                                    incomeData?.length ===
                                                                      0
                                                                      ? incomeCategories
                                                                      : sortCategories(
                                                                          incomeCategories
                                                                        ),
                                                                    categoriesListData
                                                                  ),
                                                                  index
                                                                )}
                                                                placeholder={''}
                                                                style={StyleSheet.applyWidth(
                                                                  StyleSheet.compose(
                                                                    GlobalStyles.NumberInputStyles(
                                                                      theme
                                                                    )[
                                                                      'Table Number Input'
                                                                    ].style,
                                                                    {
                                                                      color: {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          selectedIndexIncome.includes(
                                                                            findColumnRowNumber(
                                                                              index,
                                                                              findIndextAllCategories(
                                                                                sortCategories(
                                                                                  incomeCategories
                                                                                ),
                                                                                categoriesListData
                                                                              )
                                                                            )
                                                                          )
                                                                            ? Constants[
                                                                                'SWITCH_SCREEN_MODE'
                                                                              ]
                                                                              ? palettes
                                                                                  .Brand
                                                                                  .Black
                                                                              : palettes
                                                                                  .Brand
                                                                                  .White
                                                                            : palettes
                                                                                .Brand
                                                                                .Transparent,
                                                                      },
                                                                      textAlign:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'right',
                                                                        },
                                                                      zIndex: {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 1,
                                                                      },
                                                                    }
                                                                  ),
                                                                  dimensions.width
                                                                )}
                                                                webShowOutline={
                                                                  false
                                                                }
                                                              />
                                                              {/* Format View */}
                                                              <>
                                                                {selectedIndexIncome.includes(
                                                                  findColumnRowNumber(
                                                                    index,
                                                                    findIndextAllCategories(
                                                                      sortCategories(
                                                                        incomeCategories
                                                                      ),
                                                                      categoriesListData
                                                                    )
                                                                  )
                                                                ) ? null : (
                                                                  <View
                                                                    style={StyleSheet.applyWidth(
                                                                      {
                                                                        alignItems:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'center',
                                                                          },
                                                                        flexDirection:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'row',
                                                                          },
                                                                        justifyContent:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'space-between',
                                                                          },
                                                                        paddingLeft:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 4,
                                                                          },
                                                                        paddingRight:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 4,
                                                                          },
                                                                        position:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'absolute',
                                                                          },
                                                                        width: {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            '100%',
                                                                        },
                                                                        zIndex:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 0,
                                                                          },
                                                                      },
                                                                      dimensions.width
                                                                    )}
                                                                  >
                                                                    {/* $ */}
                                                                    <Text
                                                                      accessible={
                                                                        true
                                                                      }
                                                                      selectable={
                                                                        false
                                                                      }
                                                                      {...GlobalStyles.TextStyles(
                                                                        theme
                                                                      )['Text']
                                                                        .props}
                                                                      style={StyleSheet.applyWidth(
                                                                        StyleSheet.compose(
                                                                          GlobalStyles.TextStyles(
                                                                            theme
                                                                          )[
                                                                            'Text'
                                                                          ]
                                                                            .style,
                                                                          {
                                                                            color:
                                                                              {
                                                                                minWidth:
                                                                                  Breakpoints.Laptop,
                                                                                value:
                                                                                  Constants[
                                                                                    'SWITCH_SCREEN_MODE'
                                                                                  ]
                                                                                    ? palettes
                                                                                        .Brand
                                                                                        .Black
                                                                                    : palettes
                                                                                        .Brand
                                                                                        .White,
                                                                              },
                                                                            fontFamily:
                                                                              {
                                                                                minWidth:
                                                                                  Breakpoints.Laptop,
                                                                                value:
                                                                                  'OpenSans_600SemiBold',
                                                                              },
                                                                            fontSize:
                                                                              {
                                                                                minWidth:
                                                                                  Breakpoints.Laptop,
                                                                                value: 10,
                                                                              },
                                                                          }
                                                                        ),
                                                                        dimensions.width
                                                                      )}
                                                                    >
                                                                      {'$'}
                                                                    </Text>
                                                                    {/* Number Value */}
                                                                    <Text
                                                                      accessible={
                                                                        true
                                                                      }
                                                                      selectable={
                                                                        false
                                                                      }
                                                                      {...GlobalStyles.TextStyles(
                                                                        theme
                                                                      )['Text']
                                                                        .props}
                                                                      style={StyleSheet.applyWidth(
                                                                        StyleSheet.compose(
                                                                          GlobalStyles.TextStyles(
                                                                            theme
                                                                          )[
                                                                            'Text'
                                                                          ]
                                                                            .style,
                                                                          {
                                                                            color:
                                                                              {
                                                                                minWidth:
                                                                                  Breakpoints.Laptop,
                                                                                value:
                                                                                  Constants[
                                                                                    'SWITCH_SCREEN_MODE'
                                                                                  ]
                                                                                    ? palettes
                                                                                        .Brand
                                                                                        .Black
                                                                                    : palettes
                                                                                        .Brand
                                                                                        .White,
                                                                              },
                                                                            fontFamily:
                                                                              {
                                                                                minWidth:
                                                                                  Breakpoints.Laptop,
                                                                                value:
                                                                                  'OpenSans_600SemiBold',
                                                                              },
                                                                            fontSize:
                                                                              {
                                                                                minWidth:
                                                                                  Breakpoints.Laptop,
                                                                                value: 10,
                                                                              },
                                                                          }
                                                                        ),
                                                                        dimensions.width
                                                                      )}
                                                                    >
                                                                      {formatNumber(
                                                                        getInitValue(
                                                                          numberInputsIncome,
                                                                          findIndextAllCategories(
                                                                            sortCategories(
                                                                              incomeCategories
                                                                            ),
                                                                            categoriesListData
                                                                          ),
                                                                          index
                                                                        )
                                                                      )}
                                                                    </Text>
                                                                  </View>
                                                                )}
                                                              </>
                                                            </LinearGradient>
                                                          );
                                                        }}
                                                        showsHorizontalScrollIndicator={
                                                          true
                                                        }
                                                        showsVerticalScrollIndicator={
                                                          true
                                                        }
                                                        snapToAlignment={
                                                          'start'
                                                        }
                                                        horizontal={true}
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            flex: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                          },
                                                          dimensions.width
                                                        )}
                                                      />
                                                    </View>
                                                  </>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              style={StyleSheet.applyWidth(
                                                {
                                                  flex: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            />
                                          </View>
                                          {/* Right */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            <SimpleStyleFlatList
                                              data={totalIncomePerCategory}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(listData, index) =>
                                                listData?.id ??
                                                listData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(listData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'L3mUSU3R'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const listData = item;
                                                return (
                                                  <>
                                                    {/* Total Gradiant */}
                                                    <LinearGradient
                                                      endY={100}
                                                      startX={0}
                                                      startY={0}
                                                      color1={
                                                        checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Light'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Light'
                                                            ]
                                                      }
                                                      color2={
                                                        checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Dark'
                                                            ]
                                                      }
                                                      color3={null}
                                                      endX={0}
                                                      style={StyleSheet.applyWidth(
                                                        {
                                                          alignItems: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 'center',
                                                          },
                                                          borderBottomWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          borderRightWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          borderTopWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 0,
                                                          },
                                                          height: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 25,
                                                          },
                                                          justifyContent: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 'center',
                                                          },
                                                          maxHeight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 25,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: null,
                                                          },
                                                          minHeight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 25,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: [
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                (dimensions.width -
                                                                  dimensions.width *
                                                                    (15 / 100) -
                                                                  320) /
                                                                14,
                                                            },
                                                          ],
                                                        },
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Total Value */}
                                                      <Text
                                                        accessible={true}
                                                        selectable={false}
                                                        {...GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .props}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].style,
                                                            {
                                                              color: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .White
                                                                    : palettes
                                                                        .Brand
                                                                        .Black,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {'$ '}
                                                        {formatNumber(listData)}
                                                      </Text>
                                                    </LinearGradient>
                                                  </>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                            />
                                            {/* List 2 */}
                                            <SimpleStyleFlatList
                                              data={calculateBenchmark(
                                                totalIncomePerCategory
                                              )}
                                              decelerationRate={'normal'}
                                              horizontal={false}
                                              inverted={false}
                                              keyExtractor={(
                                                list2Data,
                                                index
                                              ) =>
                                                list2Data?.id ??
                                                list2Data?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(list2Data)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'V1R0knzw'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const list2Data = item;
                                                return (
                                                  <>
                                                    {/* Benchmarks */}
                                                    <LinearGradient
                                                      endY={100}
                                                      startX={0}
                                                      startY={0}
                                                      color1={
                                                        (checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Light'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Light'
                                                            ]) ??
                                                        palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      }
                                                      color2={
                                                        (checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Dark'
                                                            ]) ??
                                                        palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      }
                                                      color3={null}
                                                      endX={0}
                                                      style={StyleSheet.applyWidth(
                                                        {
                                                          alignItems: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 'center',
                                                          },
                                                          borderBottomWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          borderTopWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 0,
                                                          },
                                                          flex: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          height: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 25,
                                                          },
                                                          justifyContent: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 'center',
                                                          },
                                                          maxHeight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 25,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: null,
                                                          },
                                                          minHeight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 25,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: [
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                (dimensions.width -
                                                                  dimensions.width *
                                                                    (15 / 100) -
                                                                  320) /
                                                                14,
                                                            },
                                                          ],
                                                        },
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Benchmarks */}
                                                      <Text
                                                        accessible={true}
                                                        selectable={false}
                                                        {...GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .props}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].style,
                                                            {
                                                              color: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .White
                                                                    : palettes
                                                                        .Brand
                                                                        .Black,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {formatPercentage(
                                                          list2Data
                                                        )}
                                                      </Text>
                                                    </LinearGradient>
                                                  </>
                                                );
                                              }}
                                              showsHorizontalScrollIndicator={
                                                true
                                              }
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                            />
                                          </View>
                                        </View>
                                        {/* Bottom Total */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              bottom: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 0,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: '100%',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Total Income */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            <LinearGradient
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              color1={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              color2={
                                                palettes.App['App Blue Light']
                                              }
                                              color3={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderBottomWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderRightWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    justifyContent: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'flex-end',
                                                    },
                                                    maxWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text'].style,
                                                    {
                                                      paddingRight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 4,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'Total Income'}
                                              </Text>
                                            </LinearGradient>
                                            {/* Total Income */}
                                            <SimpleStyleFlatList
                                              data={totalIncomePerMonth.concat([
                                                '100.00%',
                                              ])}
                                              decelerationRate={'normal'}
                                              inverted={false}
                                              keyExtractor={(
                                                totalIncomeData,
                                                index
                                              ) =>
                                                totalIncomeData?.id ??
                                                totalIncomeData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(totalIncomeData)
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'5EmJRxZW'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const totalIncomeData = item;
                                                return (
                                                  <>
                                                    {/* Total Income */}
                                                    <LinearGradient
                                                      endY={100}
                                                      startX={0}
                                                      startY={0}
                                                      {...GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Blue Linear'].props}
                                                      color1={
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ]
                                                      }
                                                      color2={
                                                        palettes.App[
                                                          'App Blue Light'
                                                        ]
                                                      }
                                                      color3={
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ]
                                                      }
                                                      endX={0}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Blue Linear']
                                                            .style,
                                                          {
                                                            borderBottomWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .White,
                                                            },
                                                            borderRightWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                (dimensions.width -
                                                                  dimensions.width *
                                                                    (15 / 100) -
                                                                  320) /
                                                                14,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Total Income */}
                                                      <>
                                                        {!(
                                                          index < 13
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {'$ '}
                                                            {formatNumber(
                                                              totalIncomeData
                                                            )}
                                                          </Text>
                                                        )}
                                                      </>
                                                      {/* Benchmark */}
                                                      <>
                                                        {!(
                                                          index > 12
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {totalIncomeData}
                                                          </Text>
                                                        )}
                                                      </>
                                                    </LinearGradient>
                                                  </>
                                                );
                                              }}
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              horizontal={true}
                                              scrollEnabled={false}
                                              showsHorizontalScrollIndicator={
                                                false
                                              }
                                            />
                                          </View>
                                          {/* Total Cash Available */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 25,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Linear Gradient 2 */}
                                            <LinearGradient
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              color1={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              color2={
                                                palettes.App['App Blue Light']
                                              }
                                              color3={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderRightWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    justifyContent: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'flex-end',
                                                    },
                                                    maxWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 300,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text'].style,
                                                    {
                                                      paddingRight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 4,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {'Total Cash Available'}
                                              </Text>
                                            </LinearGradient>
                                            {/* Total Cash Available */}
                                            <SimpleStyleFlatList
                                              data={totalCashAvailable.concat([
                                                '',
                                                '',
                                              ])}
                                              decelerationRate={'normal'}
                                              inverted={false}
                                              keyExtractor={(
                                                totalCashAvailableData,
                                                index
                                              ) =>
                                                totalCashAvailableData?.id ??
                                                totalCashAvailableData?.uuid ??
                                                index?.toString() ??
                                                JSON.stringify(
                                                  totalCashAvailableData
                                                )
                                              }
                                              keyboardShouldPersistTaps={
                                                'never'
                                              }
                                              listKey={'Wvp79UBp'}
                                              nestedScrollEnabled={false}
                                              numColumns={1}
                                              onEndReachedThreshold={0.5}
                                              pagingEnabled={false}
                                              renderItem={({ item, index }) => {
                                                const totalCashAvailableData =
                                                  item;
                                                return (
                                                  <>
                                                    {/* Total Income */}
                                                    <LinearGradient
                                                      endY={100}
                                                      startX={0}
                                                      startY={0}
                                                      {...GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Blue Linear'].props}
                                                      color1={
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ]
                                                      }
                                                      color2={
                                                        palettes.App[
                                                          'App Blue Light'
                                                        ]
                                                      }
                                                      color3={
                                                        palettes.Brand[
                                                          'App Blue Dark'
                                                        ]
                                                      }
                                                      endX={0}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Blue Linear']
                                                            .style,
                                                          {
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .White,
                                                            },
                                                            borderRightWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                (dimensions.width -
                                                                  dimensions.width *
                                                                    (15 / 100) -
                                                                  320) /
                                                                14,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Total Income */}
                                                      <>
                                                        {!(
                                                          index <= 11
                                                        ) ? null : (
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .props}
                                                            style={StyleSheet.applyWidth(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .style,
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {'$ '}
                                                            {formatNumber(
                                                              totalCashAvailableData
                                                            )}
                                                          </Text>
                                                        )}
                                                      </>
                                                    </LinearGradient>
                                                  </>
                                                );
                                              }}
                                              showsVerticalScrollIndicator={
                                                true
                                              }
                                              snapToAlignment={'start'}
                                              horizontal={true}
                                              scrollEnabled={false}
                                              showsHorizontalScrollIndicator={
                                                false
                                              }
                                            />
                                          </View>
                                        </View>
                                      </View>
                                      {/* Expense */}
                                      <View>
                                        {/* Product Payments */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              borderBottomWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.White,
                                              },
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              marginTop: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Linear Gradient 2 */}
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].props}
                                            color1={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            color2={
                                              palettes.App['App Blue Light']
                                            }
                                            color3={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].style,
                                                {
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  borderRightWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  justifyContent: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  maxWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  minWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  {
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Product Payments'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Product Payments */}
                                          <SimpleStyleFlatList
                                            data={totalPaymentForCostPerMonth.concat(
                                              calculatePercentIncome(
                                                totalIncomePerMonth.slice(
                                                  0,
                                                  12
                                                ),
                                                totalPaymentForCostPerMonth.slice(
                                                  12,
                                                  undefined
                                                )
                                              )
                                            )}
                                            decelerationRate={'normal'}
                                            inverted={false}
                                            keyExtractor={(
                                              productPaymentsData,
                                              index
                                            ) =>
                                              productPaymentsData?.id ??
                                              productPaymentsData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(
                                                productPaymentsData
                                              )
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'AA7YrHsm'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const productPaymentsData = item;
                                              return (
                                                <>
                                                  {/* Product Payments */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].props}
                                                    color1={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    color2={
                                                      palettes.App[
                                                        'App Blue Light'
                                                      ]
                                                    }
                                                    color3={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          borderRightWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          maxHeight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 25,
                                                          },
                                                          minHeight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 25,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: [
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                (dimensions.width -
                                                                  dimensions.width *
                                                                    (15 / 100) -
                                                                  320) /
                                                                14,
                                                            },
                                                          ],
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <>
                                                      {!(index <= 11) ? null : (
                                                        <NumberInput
                                                          changeTextDelay={500}
                                                          onBlur={() => {
                                                            const numberInputValue =
                                                              undefined;
                                                            try {
                                                              setSelectedIndexCogs(
                                                                addOrRemove(
                                                                  selectedIndexCogs,
                                                                  index,
                                                                  0
                                                                )
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          onChangeText={newNumberInputValue => {
                                                            const numberInputValue =
                                                              newNumberInputValue;
                                                            try {
                                                              updateTableRows(
                                                                index,
                                                                0,
                                                                newNumberInputValue,
                                                                numberInputsPaymentForCost
                                                              );
                                                              setTotalPaymentForCostPerCetagory(
                                                                totalForCategory(
                                                                  numberInputsPaymentForCost
                                                                )
                                                              );

                                                              const valueXHqzybg4 =
                                                                totalCashPaid(
                                                                  totalForMonth(
                                                                    numberInputsPaymentForCost
                                                                  ),
                                                                  totalOperatingPerMonth,
                                                                  totalFinancePerMonth
                                                                );
                                                              const total_cash_paid =
                                                                valueXHqzybg4;
                                                              setTotalCashPaidOut(
                                                                valueXHqzybg4
                                                              );
                                                              if (
                                                                (props.route
                                                                  ?.params
                                                                  ?.new_or_exist ??
                                                                  defaultProps.new_or_exist) ===
                                                                'new'
                                                              ) {
                                                                const valueQXdzUZJF =
                                                                  updateStartingBalanceWithExpenseChange(
                                                                    totalCashPaidOut,
                                                                    total_cash_paid,
                                                                    cashOnHands
                                                                  );
                                                                const new_cash_on_hands =
                                                                  valueQXdzUZJF;
                                                                setCashOnHands(
                                                                  valueQXdzUZJF
                                                                );
                                                                setTotalCashAvailable(
                                                                  sumArrays(
                                                                    totalIncomePerMonth,
                                                                    new_cash_on_hands?.beginning
                                                                  ).slice(0, 12)
                                                                );
                                                              } else {
                                                                const valueDGntA2QY =
                                                                  calculateCashOnHandFlow(
                                                                    totalIncomePerMonth,
                                                                    total_cash_paid,
                                                                    startingCashOn
                                                                  );
                                                                const cash_on_hand =
                                                                  valueDGntA2QY;
                                                                setCashOnHands(
                                                                  valueDGntA2QY
                                                                );
                                                                setTotalCashAvailable(
                                                                  sumArrays(
                                                                    totalIncomePerMonth,
                                                                    cash_on_hand?.beginning
                                                                  ).slice(0, 12)
                                                                );
                                                              }
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          onFocus={() => {
                                                            const numberInputValue =
                                                              undefined;
                                                            try {
                                                              setSelectedIndexCogs(
                                                                addOrRemove(
                                                                  selectedIndexCogs,
                                                                  index,
                                                                  0
                                                                )
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          webShowOutline={true}
                                                          {...GlobalStyles.NumberInputStyles(
                                                            theme
                                                          )[
                                                            'Table Number Input'
                                                          ].props}
                                                          defaultValue={getInitValue(
                                                            numberInputsPaymentForCost,
                                                            0,
                                                            index
                                                          )}
                                                          placeholder={''}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.NumberInputStyles(
                                                                theme
                                                              )[
                                                                'Table Number Input'
                                                              ].style,
                                                              {
                                                                color: [
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      palettes
                                                                        .Brand
                                                                        .Black,
                                                                  },
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      selectedIndexCogs.includes(
                                                                        findColumnRowNumber(
                                                                          index,
                                                                          0
                                                                        )
                                                                      )
                                                                        ? palettes
                                                                            .Brand
                                                                            .Black
                                                                        : palettes
                                                                            .Brand
                                                                            .Transparent,
                                                                  },
                                                                ],
                                                                fontFamily: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    'OpenSans_700Bold',
                                                                },
                                                                textAlign: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    'right',
                                                                },
                                                                width: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 75,
                                                                },
                                                                zIndex: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        />
                                                      )}
                                                    </>
                                                    {/* Product Payments 2 */}
                                                    <>
                                                      {!(
                                                        index === 12
                                                      ) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {formatNumber(
                                                            productPaymentsData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* Product Payments 3 */}
                                                    <>
                                                      {!(
                                                        index === 13
                                                      ) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {formatPercentage(
                                                            productPaymentsData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* Format View */}
                                                    <>
                                                      {selectedIndexCogs.includes(
                                                        findColumnRowNumber(
                                                          index,
                                                          0
                                                        )
                                                      ) ||
                                                      index >= 12 ? null : (
                                                        <View
                                                          style={StyleSheet.applyWidth(
                                                            {
                                                              alignItems: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 'center',
                                                              },
                                                              flexDirection: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 'row',
                                                              },
                                                              justifyContent: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  'space-between',
                                                              },
                                                              paddingLeft: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 4,
                                                              },
                                                              paddingRight: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 4,
                                                              },
                                                              position: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  'absolute',
                                                              },
                                                              width: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: '100%',
                                                              },
                                                              zIndex: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 0,
                                                              },
                                                            },
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {/* $ */}
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Text'].props}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Text'].style,
                                                                {
                                                                  color: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      palettes
                                                                        .Brand
                                                                        .Black,
                                                                  },
                                                                  fontFamily: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'OpenSans_700Bold',
                                                                  },
                                                                  fontSize: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 10,
                                                                  },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {'$'}
                                                          </Text>
                                                          {/* Number Value */}
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )['Text'].props}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Text'].style,
                                                                {
                                                                  color: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      palettes
                                                                        .Brand
                                                                        .Black,
                                                                  },
                                                                  fontFamily: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'OpenSans_700Bold',
                                                                  },
                                                                  fontSize: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 10,
                                                                  },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {formatNumber(
                                                              getInitValue(
                                                                numberInputsPaymentForCost,
                                                                0,
                                                                index
                                                              )
                                                            )}
                                                          </Text>
                                                        </View>
                                                      )}
                                                    </>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            horizontal={true}
                                            scrollEnabled={false}
                                            showsHorizontalScrollIndicator={
                                              false
                                            }
                                          />
                                        </View>
                                        {/* Operating Expenses */}
                                        <View>
                                          {/* Header View */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                padding: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 6,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Header */}
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Header'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Header'].style,
                                                  {
                                                    color: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.Brand.White
                                                        : palettes.Brand.Black,
                                                    },
                                                    fontSize: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 18,
                                                    },
                                                    textAlign: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'right',
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Operating Expenses'}
                                            </Text>
                                          </View>
                                          {/* Categories */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Left */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  backgroundColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: checkScreenMode(
                                                      Variables
                                                    )
                                                      ? undefined
                                                      : palettes.Brand.White,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              {/* Categories List */}
                                              <SimpleStyleFlatList
                                                data={allCategoriesOperating}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  categoriesListData,
                                                  index
                                                ) =>
                                                  categoriesListData?.id ??
                                                  categoriesListData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(
                                                    categoriesListData
                                                  )
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'V68Qs8Pf'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const categoriesListData =
                                                    item;
                                                  return (
                                                    <>
                                                      {/* Categories */}
                                                      <View
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            flexDirection: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'row',
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: '100%',
                                                            },
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        <LinearGradient
                                                          endY={100}
                                                          {...GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Linear Gradient']
                                                            .props}
                                                          color1={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Light'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Light'
                                                                ]) ??
                                                            palettes.App[
                                                              'Gray Linear Light'
                                                            ]
                                                          }
                                                          color2={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Dark'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]) ??
                                                            palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          }
                                                          endX={0}
                                                          startX={0}
                                                          startY={0}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.LinearGradientStyles(
                                                                theme
                                                              )[
                                                                'Linear Gradient'
                                                              ].style,
                                                              {
                                                                borderColor: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    palettes
                                                                      .Brand
                                                                      .Black,
                                                                },
                                                                borderLeftWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                flexDirection: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 'row',
                                                                },
                                                                height: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                justifyContent:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'flex-end',
                                                                  },
                                                                maxHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                maxWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                                minHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                                width: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {/* Categories Text */}
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].props}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )[
                                                                  'Chart Text White'
                                                                ].style,
                                                                {
                                                                  color: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      checkScreenMode(
                                                                        Variables
                                                                      )
                                                                        ? palettes
                                                                            .Brand
                                                                            .White
                                                                        : palettes
                                                                            .Brand
                                                                            .Black,
                                                                  },
                                                                  paddingLeft: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 4,
                                                                  },
                                                                  paddingRight:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 4,
                                                                    },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {categoriesListData?.default_value
                                                              ? categoriesListData
                                                                  ?._expense_heads
                                                                  ?.title
                                                              : categoriesListData?.title}
                                                          </Text>
                                                        </LinearGradient>
                                                        {/* Matrix List */}
                                                        <SimpleStyleFlatList
                                                          data={[
                                                            1, 2, 3, 4, 5, 6, 7,
                                                            8, 9, 10, 11, 12,
                                                          ]}
                                                          decelerationRate={
                                                            'normal'
                                                          }
                                                          inverted={false}
                                                          keyExtractor={(
                                                            matrixListData,
                                                            index
                                                          ) =>
                                                            matrixListData?.id ??
                                                            matrixListData?.uuid ??
                                                            index?.toString() ??
                                                            JSON.stringify(
                                                              matrixListData
                                                            )
                                                          }
                                                          keyboardShouldPersistTaps={
                                                            'never'
                                                          }
                                                          listKey={JSON.stringify(
                                                            [
                                                              1, 2, 3, 4, 5, 6,
                                                              7, 8, 9, 10, 11,
                                                              12,
                                                            ]
                                                          )}
                                                          nestedScrollEnabled={
                                                            false
                                                          }
                                                          numColumns={1}
                                                          onEndReachedThreshold={
                                                            0.5
                                                          }
                                                          pagingEnabled={false}
                                                          renderItem={({
                                                            item,
                                                            index,
                                                          }) => {
                                                            const matrixListData =
                                                              item;
                                                            return (
                                                              <LinearGradient
                                                                endY={100}
                                                                startX={0}
                                                                startY={0}
                                                                color1={
                                                                  (checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .Background
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Dark'
                                                                      ]) ??
                                                                  theme.colors
                                                                    .branding
                                                                    .primary
                                                                }
                                                                color2={
                                                                  (checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .App[
                                                                        'Gray Linear Dark'
                                                                      ]
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Light'
                                                                      ]) ??
                                                                  theme.colors
                                                                    .branding
                                                                    .secondary
                                                                }
                                                                color3={
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .Background
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Dark'
                                                                      ]
                                                                }
                                                                endX={0}
                                                                style={StyleSheet.applyWidth(
                                                                  {
                                                                    alignItems:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'center',
                                                                      },
                                                                    borderBottomWidth:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 1,
                                                                      },
                                                                    borderColor:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          palettes
                                                                            .Brand
                                                                            .Black,
                                                                      },
                                                                    borderRightWidth:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 1,
                                                                      },
                                                                    height: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    justifyContent:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'center',
                                                                      },
                                                                    maxHeight: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    minHeight: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    minWidth: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 75,
                                                                    },
                                                                    width: [
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 75,
                                                                      },
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.BigScreen,
                                                                        value:
                                                                          (dimensions.width -
                                                                            dimensions.width *
                                                                              (15 /
                                                                                100) -
                                                                            320) /
                                                                          14,
                                                                      },
                                                                    ],
                                                                  },
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {/* Number Input 3 */}
                                                                <NumberInput
                                                                  changeTextDelay={
                                                                    500
                                                                  }
                                                                  onBlur={() => {
                                                                    const numberInputValue =
                                                                      undefined;
                                                                    try {
                                                                      setSelectedIndexOperating(
                                                                        addOrRemove(
                                                                          selectedIndexOperating,
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesOperating,
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      );
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  onChangeText={newNumberInput3Value => {
                                                                    const numberInputValue =
                                                                      newNumberInput3Value;
                                                                    try {
                                                                      const updatedNumbers =
                                                                        updateTableRows(
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesOperating,
                                                                            categoriesListData
                                                                          ),
                                                                          newNumberInput3Value >=
                                                                            0
                                                                            ? newNumberInput3Value
                                                                            : 0,
                                                                          numberInputsOperating
                                                                        );
                                                                      setTotalOperatingPerCategory(
                                                                        totalForCategory(
                                                                          updatedNumbers
                                                                        )
                                                                      );

                                                                      const valuewqhtRI7w =
                                                                        totalForMonth(
                                                                          updatedNumbers
                                                                        );
                                                                      const res =
                                                                        valuewqhtRI7w;
                                                                      setTotalOperatingPerMonth(
                                                                        valuewqhtRI7w
                                                                      );
                                                                      const valueOTWDp3Sg =
                                                                        totalCashPaid(
                                                                          totalPaymentForCostPerMonth,
                                                                          res,
                                                                          totalFinancePerMonth
                                                                        );
                                                                      const total_cash_paid =
                                                                        valueOTWDp3Sg;
                                                                      setTotalCashPaidOut(
                                                                        valueOTWDp3Sg
                                                                      );
                                                                      if (
                                                                        (props
                                                                          .route
                                                                          ?.params
                                                                          ?.new_or_exist ??
                                                                          defaultProps.new_or_exist) ===
                                                                        'new'
                                                                      ) {
                                                                        const valuenRhq8PpR =
                                                                          updateStartingBalanceWithExpenseChange(
                                                                            totalCashPaidOut,
                                                                            total_cash_paid,
                                                                            cashOnHands
                                                                          );
                                                                        const new_cash_on_hand =
                                                                          valuenRhq8PpR;
                                                                        setCashOnHands(
                                                                          valuenRhq8PpR
                                                                        );
                                                                        setTotalCashAvailable(
                                                                          sumArrays(
                                                                            new_cash_on_hand?.beginning,
                                                                            totalIncomePerMonth
                                                                          ).slice(
                                                                            0,
                                                                            12
                                                                          )
                                                                        );
                                                                      } else {
                                                                        const valueG0mzNsmT =
                                                                          calculateCashOnHandFlow(
                                                                            totalIncomePerMonth,
                                                                            total_cash_paid,
                                                                            startingCashOn
                                                                          );
                                                                        const cash_on_hand =
                                                                          valueG0mzNsmT;
                                                                        setCashOnHands(
                                                                          valueG0mzNsmT
                                                                        );
                                                                        setTotalCashAvailable(
                                                                          sumArrays(
                                                                            totalIncomePerMonth,
                                                                            cash_on_hand?.beginning
                                                                          ).slice(
                                                                            0,
                                                                            12
                                                                          )
                                                                        );
                                                                      }
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  onFocus={() => {
                                                                    const numberInputValue =
                                                                      undefined;
                                                                    try {
                                                                      setSelectedIndexOperating(
                                                                        addOrRemove(
                                                                          selectedIndexOperating,
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesOperating,
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      );
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  webShowOutline={
                                                                    true
                                                                  }
                                                                  {...GlobalStyles.NumberInputStyles(
                                                                    theme
                                                                  )[
                                                                    'Table Number Input'
                                                                  ].props}
                                                                  defaultValue={getInitValue(
                                                                    numberInputsOperating,
                                                                    findIndexExpense(
                                                                      sortCategoriesExpense(
                                                                        allCategoriesOperating
                                                                      ),
                                                                      categoriesListData
                                                                    ),
                                                                    index
                                                                  )}
                                                                  placeholder={
                                                                    ''
                                                                  }
                                                                  style={StyleSheet.applyWidth(
                                                                    StyleSheet.compose(
                                                                      GlobalStyles.NumberInputStyles(
                                                                        theme
                                                                      )[
                                                                        'Table Number Input'
                                                                      ].style,
                                                                      {
                                                                        color: {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            selectedIndexOperating.includes(
                                                                              findColumnRowNumber(
                                                                                index,
                                                                                findIndexExpense(
                                                                                  sortCategoriesExpense(
                                                                                    allCategoriesOperating
                                                                                  ),
                                                                                  categoriesListData
                                                                                )
                                                                              )
                                                                            )
                                                                              ? Constants[
                                                                                  'SWITCH_SCREEN_MODE'
                                                                                ]
                                                                                ? palettes
                                                                                    .Brand
                                                                                    .Black
                                                                                : palettes
                                                                                    .Brand
                                                                                    .White
                                                                              : palettes
                                                                                  .Brand
                                                                                  .Transparent,
                                                                        },
                                                                        textAlign:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'right',
                                                                          },
                                                                        zIndex:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 1,
                                                                          },
                                                                      }
                                                                    ),
                                                                    dimensions.width
                                                                  )}
                                                                />
                                                                {/* Format View */}
                                                                <>
                                                                  {selectedIndexOperating.includes(
                                                                    findColumnRowNumber(
                                                                      index,
                                                                      findIndexExpense(
                                                                        sortCategoriesExpense(
                                                                          allCategoriesOperating
                                                                        ),
                                                                        categoriesListData
                                                                      )
                                                                    )
                                                                  ) ? null : (
                                                                    <View
                                                                      style={StyleSheet.applyWidth(
                                                                        {
                                                                          alignItems:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'center',
                                                                            },
                                                                          flexDirection:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'row',
                                                                            },
                                                                          justifyContent:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'space-between',
                                                                            },
                                                                          paddingLeft:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 4,
                                                                            },
                                                                          paddingRight:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 4,
                                                                            },
                                                                          position:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'absolute',
                                                                            },
                                                                          width:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                '100%',
                                                                            },
                                                                          zIndex:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 0,
                                                                            },
                                                                        },
                                                                        dimensions.width
                                                                      )}
                                                                    >
                                                                      {/* $ */}
                                                                      <Text
                                                                        accessible={
                                                                          true
                                                                        }
                                                                        selectable={
                                                                          false
                                                                        }
                                                                        {...GlobalStyles.TextStyles(
                                                                          theme
                                                                        )[
                                                                          'Text'
                                                                        ].props}
                                                                        style={StyleSheet.applyWidth(
                                                                          StyleSheet.compose(
                                                                            GlobalStyles.TextStyles(
                                                                              theme
                                                                            )[
                                                                              'Text'
                                                                            ]
                                                                              .style,
                                                                            {
                                                                              color:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    Constants[
                                                                                      'SWITCH_SCREEN_MODE'
                                                                                    ]
                                                                                      ? palettes
                                                                                          .Brand
                                                                                          .Black
                                                                                      : palettes
                                                                                          .Brand
                                                                                          .White,
                                                                                },
                                                                              fontFamily:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    'OpenSans_600SemiBold',
                                                                                },
                                                                              fontSize:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value: 10,
                                                                                },
                                                                            }
                                                                          ),
                                                                          dimensions.width
                                                                        )}
                                                                      >
                                                                        {'$'}
                                                                      </Text>
                                                                      {/* Number Value */}
                                                                      <Text
                                                                        accessible={
                                                                          true
                                                                        }
                                                                        selectable={
                                                                          false
                                                                        }
                                                                        {...GlobalStyles.TextStyles(
                                                                          theme
                                                                        )[
                                                                          'Text'
                                                                        ].props}
                                                                        style={StyleSheet.applyWidth(
                                                                          StyleSheet.compose(
                                                                            GlobalStyles.TextStyles(
                                                                              theme
                                                                            )[
                                                                              'Text'
                                                                            ]
                                                                              .style,
                                                                            {
                                                                              color:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    Constants[
                                                                                      'SWITCH_SCREEN_MODE'
                                                                                    ]
                                                                                      ? palettes
                                                                                          .Brand
                                                                                          .Black
                                                                                      : palettes
                                                                                          .Brand
                                                                                          .White,
                                                                                },
                                                                              fontFamily:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    'OpenSans_600SemiBold',
                                                                                },
                                                                              fontSize:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value: 10,
                                                                                },
                                                                            }
                                                                          ),
                                                                          dimensions.width
                                                                        )}
                                                                      >
                                                                        {formatNumber(
                                                                          getInitValue(
                                                                            numberInputsOperating,
                                                                            findIndexExpense(
                                                                              sortCategoriesExpense(
                                                                                allCategoriesOperating
                                                                              ),
                                                                              categoriesListData
                                                                            ),
                                                                            index
                                                                          )
                                                                        )}
                                                                      </Text>
                                                                    </View>
                                                                  )}
                                                                </>
                                                              </LinearGradient>
                                                            );
                                                          }}
                                                          showsHorizontalScrollIndicator={
                                                            true
                                                          }
                                                          showsVerticalScrollIndicator={
                                                            true
                                                          }
                                                          snapToAlignment={
                                                            'start'
                                                          }
                                                          horizontal={true}
                                                          style={StyleSheet.applyWidth(
                                                            {
                                                              flex: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 1,
                                                              },
                                                            },
                                                            dimensions.width
                                                          )}
                                                        />
                                                      </View>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                                style={StyleSheet.applyWidth(
                                                  {
                                                    flex: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                  },
                                                  dimensions.width
                                                )}
                                              />
                                            </View>
                                            {/* Right */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  flexDirection: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'row',
                                                  },
                                                  position: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'absolute',
                                                  },
                                                  right: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 0,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              <SimpleStyleFlatList
                                                data={totalOperatingPerCategory}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  listData,
                                                  index
                                                ) =>
                                                  listData?.id ??
                                                  listData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(listData)
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'EDRlnqxj'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const listData = item;
                                                  return (
                                                    <>
                                                      {/* Total Gradiant */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        {...GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Category Gradient']
                                                          .props}
                                                        color1={
                                                          checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Light'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]
                                                        }
                                                        color2={
                                                          checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]
                                                        }
                                                        color3={null}
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.LinearGradientStyles(
                                                              theme
                                                            )[
                                                              'Category Gradient'
                                                            ].style,
                                                            {
                                                              flex: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: null,
                                                              },
                                                              maxWidth: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value: null,
                                                              },
                                                              width: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Total Value */}
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .props}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].style,
                                                              {
                                                                color: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    checkScreenMode(
                                                                      Variables
                                                                    )
                                                                      ? palettes
                                                                          .Brand
                                                                          .White
                                                                      : palettes
                                                                          .Brand
                                                                          .Black,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$ '}
                                                          {formatNumber(
                                                            listData
                                                          )}
                                                        </Text>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                              />
                                              {/* List 2 */}
                                              <SimpleStyleFlatList
                                                data={calculateBenchmark(
                                                  totalOperatingPerCategory
                                                )}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  list2Data,
                                                  index
                                                ) =>
                                                  list2Data?.id ??
                                                  list2Data?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(list2Data)
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'jaT2UqAT'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const list2Data = item;
                                                  return (
                                                    <>
                                                      {/* Benchmarks */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        color1={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Light'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        }
                                                        color2={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        }
                                                        color3={null}
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            alignItems: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            borderBottomWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            flex: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: null,
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            width: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            ],
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Benchmarks */}
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .props}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].style,
                                                              {
                                                                color: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    checkScreenMode(
                                                                      Variables
                                                                    )
                                                                      ? palettes
                                                                          .Brand
                                                                          .White
                                                                      : palettes
                                                                          .Brand
                                                                          .Black,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {formatPercentage(
                                                            list2Data
                                                          )}
                                                        </Text>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                              />
                                            </View>
                                          </View>
                                          {/* Bottom Total */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.Black,
                                                },
                                                bottom: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 0,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: '100%',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Total Operating Expenses */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  flex: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  flexDirection: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'row',
                                                  },
                                                  height: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 25,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              <LinearGradient
                                                endY={100}
                                                startX={0}
                                                startY={0}
                                                {...GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].props}
                                                color1={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                color2={
                                                  palettes.App['App Blue Light']
                                                }
                                                color3={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                endX={0}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].style,
                                                    {
                                                      borderBottomWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      borderColor: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          palettes.Brand.White,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'flex-end',
                                                      },
                                                      maxWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                <Text
                                                  accessible={true}
                                                  selectable={false}
                                                  {...GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text'].style,
                                                      {
                                                        paddingRight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 4,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {'Total Operating Expenses'}
                                                </Text>
                                              </LinearGradient>
                                              {/* Total Operating Expenses */}
                                              <SimpleStyleFlatList
                                                data={totalOperatingPerMonth.concat(
                                                  calculatePercentIncome(
                                                    totalIncomePerMonth.slice(
                                                      0,
                                                      12
                                                    ),
                                                    totalOperatingPerMonth.slice(
                                                      12,
                                                      undefined
                                                    )
                                                  )
                                                )}
                                                decelerationRate={'normal'}
                                                inverted={false}
                                                keyExtractor={(
                                                  totalOperatingExpensesData,
                                                  index
                                                ) =>
                                                  totalOperatingExpensesData?.id ??
                                                  totalOperatingExpensesData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(
                                                    totalOperatingExpensesData
                                                  )
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'FETtaZPI'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const totalOperatingExpensesData =
                                                    item;
                                                  return (
                                                    <>
                                                      {/* Total Operating Expenses */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        {...GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].props}
                                                        color1={
                                                          palettes.Brand[
                                                            'App Blue Dark'
                                                          ]
                                                        }
                                                        color2={
                                                          palettes.App[
                                                            'App Blue Light'
                                                          ]
                                                        }
                                                        color3={
                                                          palettes.Brand[
                                                            'App Blue Dark'
                                                          ]
                                                        }
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.LinearGradientStyles(
                                                              theme
                                                            )['Blue Linear']
                                                              .style,
                                                            {
                                                              borderBottomWidth:
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              borderColor: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  palettes.Brand
                                                                    .White,
                                                              },
                                                              borderRightWidth:
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              minWidth: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              width: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Total Operating Expenses */}
                                                        <>
                                                          {!(
                                                            index < 13
                                                          ) ? null : (
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .props}
                                                              style={StyleSheet.applyWidth(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Chart Text']
                                                                  .style,
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {'$ '}
                                                              {formatNumber(
                                                                totalOperatingExpensesData
                                                              )}
                                                            </Text>
                                                          )}
                                                        </>
                                                        {/* %Income */}
                                                        <>
                                                          {!(
                                                            index === 13
                                                          ) ? null : (
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .props}
                                                              style={StyleSheet.applyWidth(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Chart Text']
                                                                  .style,
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {formatPercentage(
                                                                totalOperatingExpensesData
                                                              )}
                                                            </Text>
                                                          )}
                                                        </>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                                horizontal={true}
                                                scrollEnabled={false}
                                                showsHorizontalScrollIndicator={
                                                  false
                                                }
                                              />
                                            </View>
                                          </View>
                                        </View>
                                        {/* Finance Expenses */}
                                        <View>
                                          {/* Header View */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                padding: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 6,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Header */}
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Header'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Header'].style,
                                                  {
                                                    color: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.Brand.White
                                                        : palettes.Brand.Black,
                                                    },
                                                    fontSize: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 18,
                                                    },
                                                    textAlign: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'right',
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Finance Expenses'}
                                            </Text>
                                          </View>
                                          {/* Categories */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Left */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  backgroundColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: checkScreenMode(
                                                      Variables
                                                    )
                                                      ? undefined
                                                      : palettes.Brand.White,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              {/* Categories List */}
                                              <SimpleStyleFlatList
                                                data={allCategoriesFinance}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  categoriesListData,
                                                  index
                                                ) =>
                                                  categoriesListData?.id ??
                                                  categoriesListData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(
                                                    categoriesListData
                                                  )
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'tbhaEm9p'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const categoriesListData =
                                                    item;
                                                  return (
                                                    <>
                                                      {/* Categories */}
                                                      <View
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            flexDirection: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'row',
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: '100%',
                                                            },
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        <LinearGradient
                                                          endY={100}
                                                          {...GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Linear Gradient']
                                                            .props}
                                                          color1={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Light'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Light'
                                                                ]) ??
                                                            palettes.App[
                                                              'Gray Linear Light'
                                                            ]
                                                          }
                                                          color2={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Dark'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]) ??
                                                            palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          }
                                                          endX={0}
                                                          startX={0}
                                                          startY={0}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.LinearGradientStyles(
                                                                theme
                                                              )[
                                                                'Linear Gradient'
                                                              ].style,
                                                              {
                                                                borderColor: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    palettes
                                                                      .Brand
                                                                      .Black,
                                                                },
                                                                borderLeftWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                flexDirection: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 'row',
                                                                },
                                                                height: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                justifyContent:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'flex-end',
                                                                  },
                                                                maxHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                maxWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                                minHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                                width: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {/* Categories Text */}
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].props}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )[
                                                                  'Chart Text White'
                                                                ].style,
                                                                {
                                                                  color: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      checkScreenMode(
                                                                        Variables
                                                                      )
                                                                        ? palettes
                                                                            .Brand
                                                                            .White
                                                                        : palettes
                                                                            .Brand
                                                                            .Black,
                                                                  },
                                                                  paddingLeft: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 4,
                                                                  },
                                                                  paddingRight:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 4,
                                                                    },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {categoriesListData?.default_value
                                                              ? categoriesListData
                                                                  ?._expense_heads
                                                                  ?.title
                                                              : categoriesListData?.title}
                                                          </Text>
                                                        </LinearGradient>
                                                        <SimpleStyleFlatList
                                                          data={[
                                                            1, 2, 3, 4, 5, 6, 7,
                                                            8, 9, 10, 11, 12,
                                                          ]}
                                                          decelerationRate={
                                                            'normal'
                                                          }
                                                          inverted={false}
                                                          keyExtractor={(
                                                            listData,
                                                            index
                                                          ) =>
                                                            listData?.id ??
                                                            listData?.uuid ??
                                                            index?.toString() ??
                                                            JSON.stringify(
                                                              listData
                                                            )
                                                          }
                                                          keyboardShouldPersistTaps={
                                                            'never'
                                                          }
                                                          listKey={JSON.stringify(
                                                            [
                                                              1, 2, 3, 4, 5, 6,
                                                              7, 8, 9, 10, 11,
                                                              12,
                                                            ]
                                                          )}
                                                          nestedScrollEnabled={
                                                            false
                                                          }
                                                          numColumns={1}
                                                          onEndReachedThreshold={
                                                            0.5
                                                          }
                                                          pagingEnabled={false}
                                                          renderItem={({
                                                            item,
                                                            index,
                                                          }) => {
                                                            const listData =
                                                              item;
                                                            return (
                                                              <LinearGradient
                                                                endY={100}
                                                                startX={0}
                                                                startY={0}
                                                                color1={
                                                                  (checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .Background
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Dark'
                                                                      ]) ??
                                                                  theme.colors
                                                                    .branding
                                                                    .primary
                                                                }
                                                                color2={
                                                                  (checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .App[
                                                                        'Gray Linear Dark'
                                                                      ]
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Light'
                                                                      ]) ??
                                                                  theme.colors
                                                                    .branding
                                                                    .secondary
                                                                }
                                                                color3={
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .Background
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Dark'
                                                                      ]
                                                                }
                                                                endX={0}
                                                                style={StyleSheet.applyWidth(
                                                                  {
                                                                    alignItems:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'center',
                                                                      },
                                                                    borderBottomWidth:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 1,
                                                                      },
                                                                    borderColor:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          palettes
                                                                            .Brand
                                                                            .Black,
                                                                      },
                                                                    borderRightWidth:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 1,
                                                                      },
                                                                    height: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    justifyContent:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'center',
                                                                      },
                                                                    maxHeight: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    minHeight: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    minWidth: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 75,
                                                                    },
                                                                    width: [
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 75,
                                                                      },
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.BigScreen,
                                                                        value:
                                                                          (dimensions.width -
                                                                            dimensions.width *
                                                                              (15 /
                                                                                100) -
                                                                            320) /
                                                                          14,
                                                                      },
                                                                    ],
                                                                  },
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {/* Number Input 2 */}
                                                                <NumberInput
                                                                  changeTextDelay={
                                                                    500
                                                                  }
                                                                  onBlur={() => {
                                                                    try {
                                                                      setSelectedIndexFinance(
                                                                        addOrRemove(
                                                                          selectedIndexFinance,
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesFinance,
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      );
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  onChangeText={newNumberInput2Value => {
                                                                    try {
                                                                      const updatedNumbers =
                                                                        updateTableRows(
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesFinance,
                                                                            categoriesListData
                                                                          ),
                                                                          newNumberInput2Value >=
                                                                            0
                                                                            ? newNumberInput2Value
                                                                            : 0,
                                                                          numberInputsFinance
                                                                        );
                                                                      setTotalFinancePerCategory(
                                                                        totalForCategory(
                                                                          updatedNumbers
                                                                        )
                                                                      );

                                                                      const valueQkREm63q =
                                                                        totalForMonth(
                                                                          updatedNumbers
                                                                        );
                                                                      const totalFinanceMonth =
                                                                        valueQkREm63q;
                                                                      setTotalFinancePerMonth(
                                                                        valueQkREm63q
                                                                      );
                                                                      const valuevcLJ0jwV =
                                                                        totalCashPaid(
                                                                          totalPaymentForCostPerMonth,
                                                                          totalOperatingPerMonth,
                                                                          totalFinanceMonth
                                                                        );
                                                                      const total_cash_paid =
                                                                        valuevcLJ0jwV;
                                                                      setTotalCashPaidOut(
                                                                        valuevcLJ0jwV
                                                                      );
                                                                      if (
                                                                        (props
                                                                          .route
                                                                          ?.params
                                                                          ?.new_or_exist ??
                                                                          defaultProps.new_or_exist) ===
                                                                        'new'
                                                                      ) {
                                                                        const valuer2xy5M6r =
                                                                          updateStartingBalanceWithExpenseChange(
                                                                            totalCashPaidOut,
                                                                            total_cash_paid,
                                                                            cashOnHands
                                                                          );
                                                                        const new_cash_on_hands =
                                                                          valuer2xy5M6r;
                                                                        setCashOnHands(
                                                                          valuer2xy5M6r
                                                                        );
                                                                        setTotalCashAvailable(
                                                                          sumArrays(
                                                                            new_cash_on_hands?.beginning,
                                                                            totalIncomePerMonth
                                                                          ).slice(
                                                                            0,
                                                                            12
                                                                          )
                                                                        );
                                                                      } else {
                                                                        const valueIdqpqzyF =
                                                                          calculateCashOnHandFlow(
                                                                            totalIncomePerMonth,
                                                                            total_cash_paid,
                                                                            startingCashOn
                                                                          );
                                                                        const cash_on_hand =
                                                                          valueIdqpqzyF;
                                                                        setCashOnHands(
                                                                          valueIdqpqzyF
                                                                        );
                                                                        setTotalCashAvailable(
                                                                          sumArrays(
                                                                            totalIncomePerMonth,
                                                                            cash_on_hand?.beginning
                                                                          ).slice(
                                                                            0,
                                                                            12
                                                                          )
                                                                        );
                                                                      }
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  onFocus={() => {
                                                                    try {
                                                                      setSelectedIndexFinance(
                                                                        addOrRemove(
                                                                          selectedIndexFinance,
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesFinance,
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      );
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  webShowOutline={
                                                                    true
                                                                  }
                                                                  {...GlobalStyles.NumberInputStyles(
                                                                    theme
                                                                  )[
                                                                    'Table Number Input'
                                                                  ].props}
                                                                  defaultValue={getInitValue(
                                                                    numberInputsFinance,
                                                                    findIndexExpense(
                                                                      sortCategoriesExpense(
                                                                        allCategoriesFinance
                                                                      ),
                                                                      categoriesListData
                                                                    ),
                                                                    index
                                                                  )}
                                                                  placeholder={
                                                                    ''
                                                                  }
                                                                  style={StyleSheet.applyWidth(
                                                                    StyleSheet.compose(
                                                                      GlobalStyles.NumberInputStyles(
                                                                        theme
                                                                      )[
                                                                        'Table Number Input'
                                                                      ].style,
                                                                      {
                                                                        color: {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            selectedIndexFinance.includes(
                                                                              findColumnRowNumber(
                                                                                index,
                                                                                findIndexExpense(
                                                                                  sortCategoriesExpense(
                                                                                    allCategoriesFinance
                                                                                  ),
                                                                                  categoriesListData
                                                                                )
                                                                              )
                                                                            )
                                                                              ? Constants[
                                                                                  'SWITCH_SCREEN_MODE'
                                                                                ]
                                                                                ? palettes
                                                                                    .Brand
                                                                                    .Black
                                                                                : palettes
                                                                                    .Brand
                                                                                    .White
                                                                              : palettes
                                                                                  .Brand
                                                                                  .Transparent,
                                                                        },
                                                                        textAlign:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'right',
                                                                          },
                                                                        zIndex:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 1,
                                                                          },
                                                                      }
                                                                    ),
                                                                    dimensions.width
                                                                  )}
                                                                />
                                                                {/* Format View */}
                                                                <>
                                                                  {selectedIndexFinance.includes(
                                                                    findColumnRowNumber(
                                                                      index,
                                                                      findIndexExpense(
                                                                        sortCategoriesExpense(
                                                                          allCategoriesFinance
                                                                        ),
                                                                        categoriesListData
                                                                      )
                                                                    )
                                                                  ) ? null : (
                                                                    <View
                                                                      style={StyleSheet.applyWidth(
                                                                        {
                                                                          alignItems:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'center',
                                                                            },
                                                                          flexDirection:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'row',
                                                                            },
                                                                          justifyContent:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'space-between',
                                                                            },
                                                                          paddingLeft:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 4,
                                                                            },
                                                                          paddingRight:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 4,
                                                                            },
                                                                          position:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'absolute',
                                                                            },
                                                                          width:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                '100%',
                                                                            },
                                                                          zIndex:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 0,
                                                                            },
                                                                        },
                                                                        dimensions.width
                                                                      )}
                                                                    >
                                                                      {/* $ */}
                                                                      <Text
                                                                        accessible={
                                                                          true
                                                                        }
                                                                        selectable={
                                                                          false
                                                                        }
                                                                        {...GlobalStyles.TextStyles(
                                                                          theme
                                                                        )[
                                                                          'Text'
                                                                        ].props}
                                                                        style={StyleSheet.applyWidth(
                                                                          StyleSheet.compose(
                                                                            GlobalStyles.TextStyles(
                                                                              theme
                                                                            )[
                                                                              'Text'
                                                                            ]
                                                                              .style,
                                                                            {
                                                                              color:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    Constants[
                                                                                      'SWITCH_SCREEN_MODE'
                                                                                    ]
                                                                                      ? palettes
                                                                                          .Brand
                                                                                          .Black
                                                                                      : palettes
                                                                                          .Brand
                                                                                          .White,
                                                                                },
                                                                              fontFamily:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    'OpenSans_600SemiBold',
                                                                                },
                                                                              fontSize:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value: 10,
                                                                                },
                                                                            }
                                                                          ),
                                                                          dimensions.width
                                                                        )}
                                                                      >
                                                                        {'$'}
                                                                      </Text>
                                                                      {/* Number Value */}
                                                                      <Text
                                                                        accessible={
                                                                          true
                                                                        }
                                                                        selectable={
                                                                          false
                                                                        }
                                                                        {...GlobalStyles.TextStyles(
                                                                          theme
                                                                        )[
                                                                          'Text'
                                                                        ].props}
                                                                        style={StyleSheet.applyWidth(
                                                                          StyleSheet.compose(
                                                                            GlobalStyles.TextStyles(
                                                                              theme
                                                                            )[
                                                                              'Text'
                                                                            ]
                                                                              .style,
                                                                            {
                                                                              color:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    Constants[
                                                                                      'SWITCH_SCREEN_MODE'
                                                                                    ]
                                                                                      ? palettes
                                                                                          .Brand
                                                                                          .Black
                                                                                      : palettes
                                                                                          .Brand
                                                                                          .White,
                                                                                },
                                                                              fontFamily:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    'OpenSans_600SemiBold',
                                                                                },
                                                                              fontSize:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value: 10,
                                                                                },
                                                                            }
                                                                          ),
                                                                          dimensions.width
                                                                        )}
                                                                      >
                                                                        {formatNumber(
                                                                          getInitValue(
                                                                            numberInputsFinance,
                                                                            findIndexExpense(
                                                                              sortCategoriesExpense(
                                                                                allCategoriesFinance
                                                                              ),
                                                                              categoriesListData
                                                                            ),
                                                                            index
                                                                          )
                                                                        )}
                                                                      </Text>
                                                                    </View>
                                                                  )}
                                                                </>
                                                              </LinearGradient>
                                                            );
                                                          }}
                                                          showsHorizontalScrollIndicator={
                                                            true
                                                          }
                                                          showsVerticalScrollIndicator={
                                                            true
                                                          }
                                                          snapToAlignment={
                                                            'start'
                                                          }
                                                          horizontal={true}
                                                          style={StyleSheet.applyWidth(
                                                            {
                                                              flex: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 1,
                                                              },
                                                            },
                                                            dimensions.width
                                                          )}
                                                        />
                                                      </View>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                                style={StyleSheet.applyWidth(
                                                  {
                                                    flex: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                  },
                                                  dimensions.width
                                                )}
                                              />
                                            </View>
                                            {/* Right */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  flexDirection: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'row',
                                                  },
                                                  position: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'absolute',
                                                  },
                                                  right: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 0,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              <SimpleStyleFlatList
                                                data={totalFinancePerCategory}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  listData,
                                                  index
                                                ) =>
                                                  listData?.id ??
                                                  listData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(listData)
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'0tkbLUai'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const listData = item;
                                                  return (
                                                    <>
                                                      {/* Total Gradiant */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        {...GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Category Gradient']
                                                          .props}
                                                        color1={
                                                          checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Light'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]
                                                        }
                                                        color2={
                                                          checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]
                                                        }
                                                        color3={null}
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.LinearGradientStyles(
                                                              theme
                                                            )[
                                                              'Category Gradient'
                                                            ].style,
                                                            {
                                                              flex: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: null,
                                                              },
                                                              maxWidth: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value: null,
                                                              },
                                                              width: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Total Value */}
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .props}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].style,
                                                              {
                                                                color: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    checkScreenMode(
                                                                      Variables
                                                                    )
                                                                      ? palettes
                                                                          .Brand
                                                                          .White
                                                                      : palettes
                                                                          .Brand
                                                                          .Black,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$ '}
                                                          {formatNumber(
                                                            listData
                                                          )}
                                                        </Text>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                              />
                                              {/* List 2 */}
                                              <SimpleStyleFlatList
                                                data={calculateBenchmark(
                                                  totalFinancePerCategory
                                                )}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  list2Data,
                                                  index
                                                ) =>
                                                  list2Data?.id ??
                                                  list2Data?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(list2Data)
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'VYFCf2tR'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const list2Data = item;
                                                  return (
                                                    <>
                                                      {/* Benchmarks */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        color1={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Light'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        }
                                                        color2={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        }
                                                        color3={null}
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            alignItems: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            borderBottomWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            flex: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: null,
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            width: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            ],
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Benchmarks */}
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .props}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].style,
                                                              {
                                                                color: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    checkScreenMode(
                                                                      Variables
                                                                    )
                                                                      ? palettes
                                                                          .Brand
                                                                          .White
                                                                      : palettes
                                                                          .Brand
                                                                          .Black,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {formatPercentage(
                                                            list2Data
                                                          )}
                                                        </Text>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                              />
                                            </View>
                                          </View>
                                          {/* Bottom Total */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                bottom: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 0,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: '100%',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Total Finance Expenses */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  flex: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  flexDirection: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'row',
                                                  },
                                                  height: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 25,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              <LinearGradient
                                                endY={100}
                                                startX={0}
                                                startY={0}
                                                {...GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].props}
                                                color1={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                color2={
                                                  palettes.App['App Blue Light']
                                                }
                                                color3={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                endX={0}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].style,
                                                    {
                                                      borderBottomWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      borderColor: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          palettes.Brand.White,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'flex-end',
                                                      },
                                                      maxWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                <Text
                                                  accessible={true}
                                                  selectable={false}
                                                  {...GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text'].style,
                                                      {
                                                        paddingRight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 4,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {'Total Finance Expenses'}
                                                </Text>
                                              </LinearGradient>
                                              {/* Total Finance Expenses */}
                                              <SimpleStyleFlatList
                                                data={totalFinancePerMonth.concat(
                                                  ['']
                                                )}
                                                decelerationRate={'normal'}
                                                inverted={false}
                                                keyExtractor={(
                                                  totalFinanceExpensesData,
                                                  index
                                                ) =>
                                                  totalFinanceExpensesData?.id ??
                                                  totalFinanceExpensesData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(
                                                    totalFinanceExpensesData
                                                  )
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'DdF8uhcz'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const totalFinanceExpensesData =
                                                    item;
                                                  return (
                                                    <>
                                                      {/* Total Finance Expenses */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        {...GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].props}
                                                        color1={
                                                          palettes.Brand[
                                                            'App Blue Dark'
                                                          ]
                                                        }
                                                        color2={
                                                          palettes.App[
                                                            'App Blue Light'
                                                          ]
                                                        }
                                                        color3={
                                                          palettes.Brand[
                                                            'App Blue Dark'
                                                          ]
                                                        }
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.LinearGradientStyles(
                                                              theme
                                                            )['Blue Linear']
                                                              .style,
                                                            {
                                                              borderBottomWidth:
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              borderColor: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  palettes.Brand
                                                                    .White,
                                                              },
                                                              borderRightWidth:
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              minWidth: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              width: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Total Finance Expenses */}
                                                        <>
                                                          {!(
                                                            index < 13
                                                          ) ? null : (
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .props}
                                                              style={StyleSheet.applyWidth(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Chart Text']
                                                                  .style,
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {'$ '}
                                                              {formatNumber(
                                                                totalFinanceExpensesData
                                                              )}
                                                            </Text>
                                                          )}
                                                        </>
                                                        {/* %Income */}
                                                        <>
                                                          {!(
                                                            index === 13
                                                          ) ? null : (
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .props}
                                                              style={StyleSheet.applyWidth(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Chart Text']
                                                                  .style,
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {calculatePercentIncome(
                                                                totalIncomePerMonth.slice(
                                                                  0,
                                                                  12
                                                                ),
                                                                totalFinancePerMonth.slice(
                                                                  12,
                                                                  undefined
                                                                )
                                                              )}
                                                              {'%'}
                                                            </Text>
                                                          )}
                                                        </>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                                horizontal={true}
                                                scrollEnabled={false}
                                                showsHorizontalScrollIndicator={
                                                  false
                                                }
                                              />
                                            </View>
                                            {/* Total Cash Paid Out */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  flex: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  flexDirection: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'row',
                                                  },
                                                  height: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 25,
                                                  },
                                                  marginTop: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 25,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              {/* Linear Gradient 2 */}
                                              <LinearGradient
                                                endY={100}
                                                startX={0}
                                                startY={0}
                                                {...GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].props}
                                                color1={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                color2={
                                                  palettes.App['App Blue Light']
                                                }
                                                color3={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                endX={0}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].style,
                                                    {
                                                      borderColor: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          palettes.Brand.White,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'flex-end',
                                                      },
                                                      maxWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                <Text
                                                  accessible={true}
                                                  selectable={false}
                                                  {...GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text'].style,
                                                      {
                                                        paddingRight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 4,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {'Total Cash Paid Out'}
                                                </Text>
                                              </LinearGradient>
                                              {/* Total Cash Paid Out */}
                                              <SimpleStyleFlatList
                                                data={totalCashPaidOut.concat([
                                                  '',
                                                ])}
                                                decelerationRate={'normal'}
                                                inverted={false}
                                                keyExtractor={(
                                                  totalCashPaidOutData,
                                                  index
                                                ) =>
                                                  totalCashPaidOutData?.id ??
                                                  totalCashPaidOutData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(
                                                    totalCashPaidOutData
                                                  )
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'hiEdkLra'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const totalCashPaidOutData =
                                                    item;
                                                  return (
                                                    <>
                                                      {/* Total Cash Paid Out */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        {...GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].props}
                                                        color1={
                                                          palettes.Brand[
                                                            'App Blue Dark'
                                                          ]
                                                        }
                                                        color2={
                                                          palettes.App[
                                                            'App Blue Light'
                                                          ]
                                                        }
                                                        color3={
                                                          palettes.Brand[
                                                            'App Blue Dark'
                                                          ]
                                                        }
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.LinearGradientStyles(
                                                              theme
                                                            )['Blue Linear']
                                                              .style,
                                                            {
                                                              borderColor: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  palettes.Brand
                                                                    .White,
                                                              },
                                                              borderRightWidth:
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              minWidth: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              width: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Total Cash Paid Out */}
                                                        <>
                                                          {!(
                                                            index < 13
                                                          ) ? null : (
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .props}
                                                              style={StyleSheet.applyWidth(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Chart Text']
                                                                  .style,
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {'$ '}
                                                              {formatNumber(
                                                                totalCashPaidOutData
                                                              )}
                                                            </Text>
                                                          )}
                                                        </>
                                                        {/* %Income */}
                                                        <>
                                                          {!(
                                                            index === 13
                                                          ) ? null : (
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .props}
                                                              style={StyleSheet.applyWidth(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Chart Text']
                                                                  .style,
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {calculatePercentIncome(
                                                                totalIncomePerMonth.slice(
                                                                  0,
                                                                  12
                                                                ),
                                                                totalCashPaidOut.slice(
                                                                  12,
                                                                  undefined
                                                                )
                                                              )}
                                                              {'%'}
                                                            </Text>
                                                          )}
                                                        </>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                                horizontal={true}
                                                scrollEnabled={false}
                                                showsHorizontalScrollIndicator={
                                                  false
                                                }
                                              />
                                            </View>
                                            {/* Cash On Hand */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  flex: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  flexDirection: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'row',
                                                  },
                                                  height: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 25,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              {/* Linear Gradient 2 */}
                                              <LinearGradient
                                                endY={100}
                                                startX={0}
                                                startY={0}
                                                {...GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].props}
                                                color1={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                color2={
                                                  palettes.App['App Blue Light']
                                                }
                                                color3={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                endX={0}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].style,
                                                    {
                                                      borderColor: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          palettes.Brand.White,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'flex-end',
                                                      },
                                                      maxWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 300,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                <Text
                                                  accessible={true}
                                                  selectable={false}
                                                  {...GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text'].style,
                                                      {
                                                        paddingRight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 4,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {
                                                    'Cash On Hand (end of month)'
                                                  }
                                                </Text>
                                              </LinearGradient>
                                              {/* Cash On Hand */}
                                              <SimpleStyleFlatList
                                                data={(cashOnHands?.ending)
                                                  .concat(
                                                    (totalIncomePerMonth &&
                                                      totalIncomePerMonth[12]) -
                                                      (totalCashPaidOut &&
                                                        totalCashPaidOut[12])
                                                  )
                                                  .concat([''])}
                                                decelerationRate={'normal'}
                                                inverted={false}
                                                keyExtractor={(
                                                  cashOnHandData,
                                                  index
                                                ) =>
                                                  cashOnHandData?.id ??
                                                  cashOnHandData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(cashOnHandData)
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'8VJiMgju'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const cashOnHandData = item;
                                                  return (
                                                    <>
                                                      {/* Cash On Hand */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        {...GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].props}
                                                        color1={
                                                          palettes.Brand[
                                                            'App Blue Dark'
                                                          ]
                                                        }
                                                        color2={
                                                          palettes.App[
                                                            'App Blue Light'
                                                          ]
                                                        }
                                                        color3={
                                                          palettes.Brand[
                                                            'App Blue Dark'
                                                          ]
                                                        }
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.LinearGradientStyles(
                                                              theme
                                                            )['Blue Linear']
                                                              .style,
                                                            {
                                                              borderColor: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  palettes.Brand
                                                                    .White,
                                                              },
                                                              borderRightWidth:
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              minWidth: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              width: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Cash On Hand */}
                                                        <>
                                                          {!(
                                                            index < 13
                                                          ) ? null : (
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .props}
                                                              style={StyleSheet.applyWidth(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Chart Text']
                                                                  .style,
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {'$ '}
                                                              {formatNumber(
                                                                cashOnHandData
                                                              )}
                                                            </Text>
                                                          )}
                                                        </>
                                                        {/* %Income */}
                                                        <>
                                                          {!(
                                                            index === 13
                                                          ) ? null : (
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )['Chart Text']
                                                                .props}
                                                              style={StyleSheet.applyWidth(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Chart Text']
                                                                  .style,
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {toFixed2(
                                                                (((totalIncomePerMonth &&
                                                                  totalIncomePerMonth[12]) -
                                                                  (totalCashPaidOut &&
                                                                    totalCashPaidOut[12])) *
                                                                  100) /
                                                                  (totalIncomePerMonth &&
                                                                    totalIncomePerMonth[12])
                                                              )}
                                                              {'%'}
                                                            </Text>
                                                          )}
                                                        </>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                                horizontal={true}
                                                scrollEnabled={false}
                                                showsHorizontalScrollIndicator={
                                                  false
                                                }
                                              />
                                            </View>
                                          </View>
                                        </View>
                                        {/* Other Operating Data */}
                                        <View>
                                          {/* Header View */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                padding: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 6,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Header */}
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Header'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Header'].style,
                                                  {
                                                    color: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.Brand.White
                                                        : palettes.Brand.Black,
                                                    },
                                                    fontSize: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 18,
                                                    },
                                                    textAlign: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'right',
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Other Operating Data'}
                                            </Text>
                                          </View>
                                          {/* Categories */}
                                          <View
                                            style={StyleSheet.applyWidth(
                                              {
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                flexDirection: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'row',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Left */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  backgroundColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: checkScreenMode(
                                                      Variables
                                                    )
                                                      ? undefined
                                                      : palettes.Brand.White,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              {/* Categories List */}
                                              <SimpleStyleFlatList
                                                data={allCategoriesOther}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  categoriesListData,
                                                  index
                                                ) =>
                                                  categoriesListData?.id ??
                                                  categoriesListData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(
                                                    categoriesListData
                                                  )
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'1iWgPxrF'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const categoriesListData =
                                                    item;
                                                  return (
                                                    <>
                                                      {/* Categories */}
                                                      <View
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            flexDirection: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'row',
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: '100%',
                                                            },
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        <LinearGradient
                                                          endY={100}
                                                          {...GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Linear Gradient']
                                                            .props}
                                                          color1={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Light'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Light'
                                                                ]) ??
                                                            palettes.App[
                                                              'Gray Linear Light'
                                                            ]
                                                          }
                                                          color2={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Dark'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]) ??
                                                            palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          }
                                                          endX={0}
                                                          startX={0}
                                                          startY={0}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.LinearGradientStyles(
                                                                theme
                                                              )[
                                                                'Linear Gradient'
                                                              ].style,
                                                              {
                                                                borderColor: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    palettes
                                                                      .Brand
                                                                      .Black,
                                                                },
                                                                borderLeftWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                flexDirection: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 'row',
                                                                },
                                                                height: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                justifyContent:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'flex-end',
                                                                  },
                                                                maxHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                maxWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                                minHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                                width: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 300,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {/* Categories Text */}
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].props}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )[
                                                                  'Chart Text White'
                                                                ].style,
                                                                {
                                                                  color: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      checkScreenMode(
                                                                        Variables
                                                                      )
                                                                        ? palettes
                                                                            .Brand
                                                                            .White
                                                                        : palettes
                                                                            .Brand
                                                                            .Black,
                                                                  },
                                                                  paddingLeft: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 4,
                                                                  },
                                                                  paddingRight:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 4,
                                                                    },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {categoriesListData?.default_value
                                                              ? categoriesListData
                                                                  ?._expense_heads
                                                                  ?.title
                                                              : categoriesListData?.title}
                                                          </Text>
                                                        </LinearGradient>
                                                        <SimpleStyleFlatList
                                                          data={[
                                                            1, 2, 3, 4, 5, 6, 7,
                                                            8, 9, 10, 11, 12,
                                                          ]}
                                                          decelerationRate={
                                                            'normal'
                                                          }
                                                          inverted={false}
                                                          keyExtractor={(
                                                            listData,
                                                            index
                                                          ) =>
                                                            listData?.id ??
                                                            listData?.uuid ??
                                                            index?.toString() ??
                                                            JSON.stringify(
                                                              listData
                                                            )
                                                          }
                                                          keyboardShouldPersistTaps={
                                                            'never'
                                                          }
                                                          listKey={JSON.stringify(
                                                            [
                                                              1, 2, 3, 4, 5, 6,
                                                              7, 8, 9, 10, 11,
                                                              12,
                                                            ]
                                                          )}
                                                          nestedScrollEnabled={
                                                            false
                                                          }
                                                          numColumns={1}
                                                          onEndReachedThreshold={
                                                            0.5
                                                          }
                                                          pagingEnabled={false}
                                                          renderItem={({
                                                            item,
                                                            index,
                                                          }) => {
                                                            const listData =
                                                              item;
                                                            return (
                                                              <LinearGradient
                                                                endY={100}
                                                                startX={0}
                                                                startY={0}
                                                                color1={
                                                                  (checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .Background
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Dark'
                                                                      ]) ??
                                                                  theme.colors
                                                                    .branding
                                                                    .primary
                                                                }
                                                                color2={
                                                                  (checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .App[
                                                                        'Gray Linear Dark'
                                                                      ]
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Light'
                                                                      ]) ??
                                                                  theme.colors
                                                                    .branding
                                                                    .secondary
                                                                }
                                                                color3={
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .Background
                                                                    : palettes
                                                                        .App[
                                                                        'Light Linear - Dark'
                                                                      ]
                                                                }
                                                                endX={0}
                                                                style={StyleSheet.applyWidth(
                                                                  {
                                                                    alignItems:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'center',
                                                                      },
                                                                    borderBottomWidth:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 1,
                                                                      },
                                                                    borderColor:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          palettes
                                                                            .Brand
                                                                            .Black,
                                                                      },
                                                                    borderRightWidth:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 1,
                                                                      },
                                                                    height: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    justifyContent:
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          'center',
                                                                      },
                                                                    maxHeight: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    minHeight: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 25,
                                                                    },
                                                                    minWidth: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 75,
                                                                    },
                                                                    width: [
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value: 75,
                                                                      },
                                                                      {
                                                                        minWidth:
                                                                          Breakpoints.BigScreen,
                                                                        value:
                                                                          (dimensions.width -
                                                                            dimensions.width *
                                                                              (15 /
                                                                                100) -
                                                                            320) /
                                                                          14,
                                                                      },
                                                                    ],
                                                                  },
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {/* Number Input 2 */}
                                                                <NumberInput
                                                                  changeTextDelay={
                                                                    500
                                                                  }
                                                                  onBlur={() => {
                                                                    try {
                                                                      setSelectedIndexOther(
                                                                        addOrRemove(
                                                                          selectedIndexOther,
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesOther,
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      );
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  onChangeText={newNumberInput2Value => {
                                                                    try {
                                                                      const updatedNumbers =
                                                                        updateTableRows(
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesOther,
                                                                            categoriesListData
                                                                          ),
                                                                          newNumberInput2Value >=
                                                                            0
                                                                            ? newNumberInput2Value
                                                                            : 0,
                                                                          numberInputsOther
                                                                        );
                                                                      setTotalOtherPerCategory(
                                                                        totalForCategory(
                                                                          updatedNumbers
                                                                        )
                                                                      );
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  onFocus={() => {
                                                                    try {
                                                                      setSelectedIndexOther(
                                                                        addOrRemove(
                                                                          selectedIndexOther,
                                                                          index,
                                                                          findIndexExpense(
                                                                            allCategoriesOther,
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      );
                                                                    } catch (err) {
                                                                      console.error(
                                                                        err
                                                                      );
                                                                    }
                                                                  }}
                                                                  webShowOutline={
                                                                    true
                                                                  }
                                                                  {...GlobalStyles.NumberInputStyles(
                                                                    theme
                                                                  )[
                                                                    'Table Number Input'
                                                                  ].props}
                                                                  defaultValue={getInitValue(
                                                                    numberInputsOther,
                                                                    findIndexExpense(
                                                                      allCategoriesOther,
                                                                      categoriesListData
                                                                    ),
                                                                    index
                                                                  )}
                                                                  placeholder={
                                                                    ''
                                                                  }
                                                                  style={StyleSheet.applyWidth(
                                                                    StyleSheet.compose(
                                                                      GlobalStyles.NumberInputStyles(
                                                                        theme
                                                                      )[
                                                                        'Table Number Input'
                                                                      ].style,
                                                                      {
                                                                        color: {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            selectedIndexOther.includes(
                                                                              findColumnRowNumber(
                                                                                index,
                                                                                findIndexExpense(
                                                                                  sortCategoriesExpense(
                                                                                    allCategoriesOther
                                                                                  ),
                                                                                  categoriesListData
                                                                                )
                                                                              )
                                                                            )
                                                                              ? Constants[
                                                                                  'SWITCH_SCREEN_MODE'
                                                                                ]
                                                                                ? palettes
                                                                                    .Brand
                                                                                    .Black
                                                                                : palettes
                                                                                    .Brand
                                                                                    .White
                                                                              : palettes
                                                                                  .Brand
                                                                                  .Transparent,
                                                                        },
                                                                        textAlign:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value:
                                                                              'right',
                                                                          },
                                                                        zIndex:
                                                                          {
                                                                            minWidth:
                                                                              Breakpoints.Laptop,
                                                                            value: 1,
                                                                          },
                                                                      }
                                                                    ),
                                                                    dimensions.width
                                                                  )}
                                                                />
                                                                {/* Format View */}
                                                                <>
                                                                  {selectedIndexOther.includes(
                                                                    findColumnRowNumber(
                                                                      index,
                                                                      findIndexExpense(
                                                                        sortCategoriesExpense(
                                                                          allCategoriesOther
                                                                        ),
                                                                        categoriesListData
                                                                      )
                                                                    )
                                                                  ) ? null : (
                                                                    <View
                                                                      style={StyleSheet.applyWidth(
                                                                        {
                                                                          alignItems:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'center',
                                                                            },
                                                                          flexDirection:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'row',
                                                                            },
                                                                          justifyContent:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'space-between',
                                                                            },
                                                                          paddingLeft:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 4,
                                                                            },
                                                                          paddingRight:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 4,
                                                                            },
                                                                          position:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                'absolute',
                                                                            },
                                                                          width:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value:
                                                                                '100%',
                                                                            },
                                                                          zIndex:
                                                                            {
                                                                              minWidth:
                                                                                Breakpoints.Laptop,
                                                                              value: 0,
                                                                            },
                                                                        },
                                                                        dimensions.width
                                                                      )}
                                                                    >
                                                                      {/* $ */}
                                                                      <Text
                                                                        accessible={
                                                                          true
                                                                        }
                                                                        selectable={
                                                                          false
                                                                        }
                                                                        {...GlobalStyles.TextStyles(
                                                                          theme
                                                                        )[
                                                                          'Text'
                                                                        ].props}
                                                                        style={StyleSheet.applyWidth(
                                                                          StyleSheet.compose(
                                                                            GlobalStyles.TextStyles(
                                                                              theme
                                                                            )[
                                                                              'Text'
                                                                            ]
                                                                              .style,
                                                                            {
                                                                              color:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    Constants[
                                                                                      'SWITCH_SCREEN_MODE'
                                                                                    ]
                                                                                      ? palettes
                                                                                          .Brand
                                                                                          .Black
                                                                                      : palettes
                                                                                          .Brand
                                                                                          .White,
                                                                                },
                                                                              fontFamily:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    'OpenSans_600SemiBold',
                                                                                },
                                                                              fontSize:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value: 10,
                                                                                },
                                                                            }
                                                                          ),
                                                                          dimensions.width
                                                                        )}
                                                                      >
                                                                        {'$'}
                                                                      </Text>
                                                                      {/* Number Value */}
                                                                      <Text
                                                                        accessible={
                                                                          true
                                                                        }
                                                                        selectable={
                                                                          false
                                                                        }
                                                                        {...GlobalStyles.TextStyles(
                                                                          theme
                                                                        )[
                                                                          'Text'
                                                                        ].props}
                                                                        style={StyleSheet.applyWidth(
                                                                          StyleSheet.compose(
                                                                            GlobalStyles.TextStyles(
                                                                              theme
                                                                            )[
                                                                              'Text'
                                                                            ]
                                                                              .style,
                                                                            {
                                                                              color:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    Constants[
                                                                                      'SWITCH_SCREEN_MODE'
                                                                                    ]
                                                                                      ? palettes
                                                                                          .Brand
                                                                                          .Black
                                                                                      : palettes
                                                                                          .Brand
                                                                                          .White,
                                                                                },
                                                                              fontFamily:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value:
                                                                                    'OpenSans_600SemiBold',
                                                                                },
                                                                              fontSize:
                                                                                {
                                                                                  minWidth:
                                                                                    Breakpoints.Laptop,
                                                                                  value: 10,
                                                                                },
                                                                            }
                                                                          ),
                                                                          dimensions.width
                                                                        )}
                                                                      >
                                                                        {formatNumber(
                                                                          getInitValue(
                                                                            numberInputsOther,
                                                                            findIndexExpense(
                                                                              sortCategoriesExpense(
                                                                                allCategoriesOther
                                                                              ),
                                                                              categoriesListData
                                                                            ),
                                                                            index
                                                                          )
                                                                        )}
                                                                      </Text>
                                                                    </View>
                                                                  )}
                                                                </>
                                                              </LinearGradient>
                                                            );
                                                          }}
                                                          showsHorizontalScrollIndicator={
                                                            true
                                                          }
                                                          showsVerticalScrollIndicator={
                                                            true
                                                          }
                                                          snapToAlignment={
                                                            'start'
                                                          }
                                                          horizontal={true}
                                                          style={StyleSheet.applyWidth(
                                                            {
                                                              flex: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 1,
                                                              },
                                                            },
                                                            dimensions.width
                                                          )}
                                                        />
                                                      </View>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                                style={StyleSheet.applyWidth(
                                                  {
                                                    flex: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                  },
                                                  dimensions.width
                                                )}
                                              />
                                            </View>
                                            {/* Right */}
                                            <View
                                              style={StyleSheet.applyWidth(
                                                {
                                                  flexDirection: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'row',
                                                  },
                                                  position: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'absolute',
                                                  },
                                                  right: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 0,
                                                  },
                                                },
                                                dimensions.width
                                              )}
                                            >
                                              <SimpleStyleFlatList
                                                data={totalOtherPerCategory}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  listData,
                                                  index
                                                ) =>
                                                  listData?.id ??
                                                  listData?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(listData)
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'ZNMHzxtm'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const listData = item;
                                                  return (
                                                    <>
                                                      {/* Total Gradiant */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        {...GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Category Gradient']
                                                          .props}
                                                        color1={
                                                          checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Light'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]
                                                        }
                                                        color2={
                                                          checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]
                                                        }
                                                        color3={null}
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.LinearGradientStyles(
                                                              theme
                                                            )[
                                                              'Category Gradient'
                                                            ].style,
                                                            {
                                                              flex: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: null,
                                                              },
                                                              maxWidth: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value: null,
                                                              },
                                                              width: {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Total Value */}
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .props}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].style,
                                                              {
                                                                color: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    checkScreenMode(
                                                                      Variables
                                                                    )
                                                                      ? palettes
                                                                          .Brand
                                                                          .White
                                                                      : palettes
                                                                          .Brand
                                                                          .Black,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$ '}
                                                          {formatNumber(
                                                            listData
                                                          )}
                                                        </Text>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                              />
                                              {/* List 2 */}
                                              <SimpleStyleFlatList
                                                data={calculateBenchmark(
                                                  totalOtherPerCategory
                                                )}
                                                decelerationRate={'normal'}
                                                horizontal={false}
                                                inverted={false}
                                                keyExtractor={(
                                                  list2Data,
                                                  index
                                                ) =>
                                                  list2Data?.id ??
                                                  list2Data?.uuid ??
                                                  index?.toString() ??
                                                  JSON.stringify(list2Data)
                                                }
                                                keyboardShouldPersistTaps={
                                                  'never'
                                                }
                                                listKey={'oX24yXTu'}
                                                nestedScrollEnabled={false}
                                                numColumns={1}
                                                onEndReachedThreshold={0.5}
                                                pagingEnabled={false}
                                                renderItem={({
                                                  item,
                                                  index,
                                                }) => {
                                                  const list2Data = item;
                                                  return (
                                                    <>
                                                      {/* Benchmarks */}
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        color1={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Light'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        }
                                                        color2={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]) ??
                                                          palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        }
                                                        color3={null}
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            alignItems: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            borderBottomWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            flex: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: null,
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            width: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    320) /
                                                                  14,
                                                              },
                                                            ],
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Benchmarks */}
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .props}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].style,
                                                              {
                                                                color: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    checkScreenMode(
                                                                      Variables
                                                                    )
                                                                      ? palettes
                                                                          .Brand
                                                                          .White
                                                                      : palettes
                                                                          .Brand
                                                                          .Black,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {formatPercentage(
                                                            list2Data
                                                          )}
                                                        </Text>
                                                      </LinearGradient>
                                                    </>
                                                  );
                                                }}
                                                showsHorizontalScrollIndicator={
                                                  true
                                                }
                                                showsVerticalScrollIndicator={
                                                  true
                                                }
                                                snapToAlignment={'start'}
                                              />
                                            </View>
                                          </View>
                                        </View>
                                      </View>
                                    </View>
                                  </View>
                                </View>
                              </SimpleStyleScrollView>

                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    paddingBottom: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 24,
                                    },
                                    paddingTop: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 24,
                                    },
                                    width: {
                                      minWidth: Breakpoints.Laptop,
                                      value: '100%',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <Button
                                  accessible={true}
                                  iconPosition={'left'}
                                  onPress={() => {
                                    const handler = async () => {
                                      try {
                                        setIsLoading(true);
                                        /* hidden 'Set Variable' action */
                                        const incomeData =
                                          mergeCategoriesNumbers(
                                            incomeCategories,
                                            numberInputsIncome,
                                            Constants['STARTING_DATE']
                                          );
                                        /* hidden 'Log to Console' action */
                                        const apiIncome = (
                                          await defaultAddingIncomeScenarioPOST.mutateAsync(
                                            {
                                              cash: startingCashOn,
                                              incomes: incomeData,
                                              scenario_id:
                                                (props.route?.params
                                                  ?.new_or_exist ??
                                                  defaultProps.new_or_exist) ===
                                                'new'
                                                  ? (
                                                      props.route?.params
                                                        ?.scenario ??
                                                      defaultProps.scenario
                                                    )?.id
                                                  : props.route?.params
                                                      ?.exist_scenario_id ??
                                                    defaultProps.exist_scenario_id,
                                              start_month: newFormatDate(
                                                Constants['STARTING_DATE'],
                                                'post'
                                              ),
                                            }
                                          )
                                        )?.json;
                                        if (apiIncome?.message) {
                                        } else {
                                          const operatingData =
                                            mergeCategoriesNumbers(
                                              allCategoriesOperating,
                                              numberInputsOperating,
                                              Constants['STARTING_DATE']
                                            );
                                          const cogsData =
                                            mergeCategoriesNumbers(
                                              allCategoriesPayment,
                                              numberInputsPaymentForCost,
                                              Constants['STARTING_DATE']
                                            );
                                          const financeData =
                                            mergeCategoriesNumbers(
                                              allCategoriesFinance,
                                              numberInputsFinance,
                                              Constants['STARTING_DATE']
                                            );
                                          const otherData =
                                            mergeCategoriesNumbers(
                                              allCategoriesOther,
                                              numberInputsOther,
                                              Constants['STARTING_DATE']
                                            );
                                          const apiExpenses = (
                                            await defaultAddingExpensesScenarioPOST.mutateAsync(
                                              {
                                                expenses: createObjectForPost(
                                                  cogsData,
                                                  financeData,
                                                  otherData,
                                                  operatingData
                                                ),
                                                scenario_id:
                                                  (props.route?.params
                                                    ?.new_or_exist ??
                                                    defaultProps.new_or_exist) ===
                                                  'new'
                                                    ? (
                                                        props.route?.params
                                                          ?.scenario ??
                                                        defaultProps.scenario
                                                      )?.id
                                                    : props.route?.params
                                                        ?.exist_scenario_id ??
                                                      defaultProps.exist_scenario_id,
                                              }
                                            )
                                          )?.json;
                                        }

                                        /* hidden 'Set Variable' action */
                                        setIsLoading(false);
                                      } catch (err) {
                                        console.error(err);
                                      }
                                    };
                                    handler();
                                  }}
                                  {...GlobalStyles.ButtonStyles(theme)[
                                    'Submit Button'
                                  ].props}
                                  loading={isUploading}
                                  style={StyleSheet.applyWidth(
                                    GlobalStyles.ButtonStyles(theme)[
                                      'Submit Button'
                                    ].style,
                                    dimensions.width
                                  )}
                                  title={'Submit'}
                                />
                              </View>
                            </SimpleStyleScrollView>
                          )}
                        </>
                      );
                    }}
                  </DefaultApi.FetchGetExpenseHeadsGET>
                )}
              </>
            </View>

            <Modal
              animationType={'none'}
              supportedOrientations={['portrait', 'landscape']}
              transparent={true}
              visible={visibleWhatIf}
            >
              <BlurView
                intensity={50}
                tint={'default'}
                {...GlobalStyles.BlurViewStyles(theme)['Scenario Blur'].props}
                style={StyleSheet.applyWidth(
                  GlobalStyles.BlurViewStyles(theme)['Scenario Blur'].style,
                  dimensions.width
                )}
              >
                {/* Scenario 2 */}
                <ScenarioBlock
                  isFetching={isFetching}
                  isLoading={isLoading}
                  reFetch={reFetch}
                  setIsFetching={isFetching => setIsFetching(isFetching)}
                  setIsLoading={isLoading => setIsLoading(isLoading)}
                  setReFetch={reFetch => setReFetch(reFetch)}
                  setVisibleWhatIf={visibleWhatIf =>
                    setVisibleWhatIf(visibleWhatIf)
                  }
                  visibleWhatIf={visibleWhatIf}
                />
              </BlurView>
            </Modal>
          </View>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(WhatIfScreen);
